/* eslint-disable max-len */
import React from 'react';

const Waiting = (
  <svg
    viewBox="0 0 1144 864"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient
        x1="50.0005261%"
        y1="100%"
        x2="50.0005261%"
        y2="0%"
        id="linearGradient-1"
      >
        <stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
        <stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
        <stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50.0236433%"
        y1="99.9948155%"
        x2="50.0236433%"
        y2="-0.0255496052%"
        id="linearGradient-2"
      >
        <stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
        <stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
        <stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="48.7540964%"
        y1="100.101185%"
        x2="50.8286201%"
        y2="-1.05136561%"
        id="linearGradient-3"
      >
        <stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
        <stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
        <stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="undraw_content_vbqo">
        <ellipse
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="1023.75"
          cy="835.07"
          rx="100.11"
          ry="24.73"
        />
        <ellipse
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="140.04"
          cy="839.19"
          rx="100.11"
          ry="24.73"
        />
        <path
          d="M684.74,233.87 C684.74,233.87 670.67,228.16 625.93,248.69 C581.19,269.22 575.57,266.6 564.01,263.46 C552.45,260.32 546.01,259.58 533.55,242.46 C533.55,242.46 524.79,194.98 516.32,187.62 C507.85,180.26 471.82,191.81 471.82,191.81 C471.82,191.81 428.63,201.72 420.4,144 C420.4,144 426.24,100.49 418.29,87.14 C418.29,87.14 434.29,94.07 460.83,82.89 C487.37,71.71 508.52,94.89 508.52,94.89 C508.52,94.89 515.2,112.19 514.52,122.5 C513.84,132.81 518.05,136.68 530.69,131.7 C530.69,131.7 536.89,122.87 528.1,108.28 C519.31,93.69 513.04,82.81 515.5,71.48 C517.96,60.15 525,44.48 547.66,36.58 C570.32,28.68 601.1,27.2 615.88,21.05 C630.66,14.9 634.23,10.9 634.23,10.9 C634.23,10.9 625.12,20.04 646.57,58.65 C668.02,97.26 654.34,114.03 654.34,114.03 C654.34,114.03 642.94,141.19 592.64,139.03 C592.64,139.03 544.17,140.8 570.64,161.36 C570.64,161.36 587.57,157.91 612.87,149.87 C638.17,141.83 656.44,175.02 660.97,198.12 C665.5,221.22 684.74,233.87 684.74,233.87 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M619.57,40.21 L619.84,40.14 C621.78,47.51 600.11,77.14 581.6,100.67 L581.38,100.5 C607.51,67.29 621.08,45.88 619.57,40.21 Z"
          id="Path"
          fill="#444053"
          fillRule="nonzero"
        />
        <path
          d="M581.77,100.01 L581.88,100.31 C567.09,119.12 548.49,141.56 533.6,158.18 C532.18,159.77 530.77,161.43 529.41,163.13 L528.99,162.78 C530.35,161.08 531.77,159.41 533.19,157.78 C548.07,141.21 566.99,118.81 581.77,100.01 Z"
          id="Path"
          fill="#444053"
          fillRule="nonzero"
        />
        <path
          d="M529.35,162.34 L529.64,162.84 C502.54,196.67 500.75,249.2 500.64,249.66 L494.92,243.06 C495.04,242.6 502.06,196.4 529.35,162.34 Z"
          id="Path"
          fill="#444053"
          fillRule="nonzero"
        />
        <path
          d="M653.31,215.52 C653.31,215.52 621.31,198.91 596.46,204.87 C571.61,210.83 515.46,183.81 515.46,183.81 C515.46,183.81 491.65,174.13 486.87,163.11 C486.87,163.11 470.54,145.85 469.61,136.91 C468.68,127.97 452.78,105.51 442.41,104.64"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M648.69,231.51 C648.69,231.51 632.57,220.67 634.47,208.04"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M624,245.52 C624,245.52 601,237.16 598.68,204.41"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M586.87,254 C586.87,254 564.87,235.75 572.18,203.87"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M542.25,245.08 C542.25,245.08 527.6,214.37 540.63,194.39"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M653.69,195.28 C653.69,195.28 637.04,200.56 640.61,209.28"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M633.57,165.07 C633.57,165.07 611.3,172.14 610.77,203.64"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M602.57,157.8 C602.57,157.8 582.31,182.8 583.8,205.55"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M567.05,167.61 C567.05,167.61 546.92,186.85 549.49,197.56"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M554.91,160.81 C554.91,160.81 536.03,164.2 533.39,158"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M530.38,138.02 C530.38,138.02 539.92,150.65 542.38,147.82"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M624.93,130.03 C624.93,130.03 577.35,133.46 566.57,119.14"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M520.37,74.37 C520.37,74.37 542.7,122.3 558.91,128.37"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M543.79,51.54 C543.79,51.54 557.51,95.63 574.5,109.39"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M644.96,93.65 C644.96,93.65 608.77,109.18 587.04,93.47"
          id="Path"
          stroke="#444053"
          strokeWidth="0.75"
        />
        <path
          d="M576.03,42.14 C576.03,42.14 584.3,74.55 595.44,82.38"
          id="Path"
          stroke="#444053"
          strokeWidth="0.75"
        />
        <path
          d="M639.49,57.35 C639.49,57.35 619.16,65.05 611.56,59.15"
          id="Path"
          stroke="#444053"
          strokeWidth="0.75"
        />
        <path
          d="M512.96,148.61 C512.96,148.61 512.96,176.86 505.27,178.87"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M450.09,185.21 C450.09,185.21 480.63,187.83 494.72,172.07"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M505.08,115.24 C505.08,115.24 497.69,143.89 477.3,151.61"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M431.77,155.03 C431.77,155.03 453.39,162.55 471.98,143.41"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M481.04,90.61 C481.04,90.61 479.04,114.94 465.77,126.33"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M432.57,117.95 C432.57,117.95 450.51,118.08 454.71,112.23"
          id="Path"
          stroke="#444053"
        />
        <path
          d="M591.97,138.46 C520.57,150.37 449.06,143.96 380.22,135.08 C311.38,126.2 242.7,114.86 171.15,117.08 C125.15,118.52 73.98,127.56 42.15,155.3 C11.53,181.99 7.15,218.48 7.44,251.48 C7.66,276.3 9.99,302.01 26.8,321.97 C38.47,335.82 56.31,345.88 69.8,358.69 C116.8,403.27 103.47,472.33 73.71,530.81 C59.71,558.25 42.6,585.18 33.21,613.31 C23.82,641.44 22.89,671.74 40.57,695.03 C58.11,718.12 91.66,731.42 126.57,738.55 C197.46,753.02 276.14,745.55 352.24,735.16 C520.68,712.05 687.24,674.67 853.32,637.36 C914.79,623.56 976.53,609.68 1035.67,589.36 C1068.51,578.1 1101.92,563.93 1122.95,541.52 C1149.64,513.07 1149.88,473.8 1123.51,449.98 C1079.27,409.98 980.3,417.5 945.91,371.98 C926.97,346.98 934.68,313.36 949.15,283.81 C980.15,220.41 1040.9,158.16 1032.15,94.45 C1026.15,50.69 983.77,14.05 927.47,3.92 C868.47,-6.69 793.06,11.03 759.69,54.54 C725.33,99.46 655.01,127.96 591.97,138.46 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
        />
        <rect
          id="Rectangle"
          fill="url(#linearGradient-1)"
          fillRule="nonzero"
          x="76.29"
          y="151.11"
          width="950.33"
          height="538.33"
          rx="12.49"
        />
        <rect
          id="Rectangle"
          fill="#FFFFFF"
          fillRule="nonzero"
          x="77.8"
          y="158.68"
          width="947.42"
          height="528.97"
          rx="12.49"
        />
        <rect
          id="Rectangle"
          fill="#FFFFFF"
          fillRule="nonzero"
          x="77.8"
          y="158.68"
          width="947.42"
          height="528.97"
          rx="12.49"
        />
        <rect
          id="Rectangle"
          fill="#5A5773"
          fillRule="nonzero"
          opacity="0.04"
          x="77.8"
          y="158.68"
          width="947.42"
          height="528.97"
          rx="12.49"
        />
        <path
          d="M1020.41,152.61 L82.57,152.61 C79.9135104,152.61 77.76,154.76351 77.76,157.42 L77.76,177.76 L1025.18017,177.76 L1025.18,157.46 C1025.19065,156.184296 1024.69408,154.956613 1023.79952,154.047052 C1022.90496,153.137491 1021.68571,152.620565 1020.41,152.61 L1020.41,152.61 Z"
          id="Path"
          fill="#5A5773"
          fillRule="nonzero"
        />
        <g
          id="83eb5f8b-b68b-4721-b047-6100bc74156f"
          transform="translate(90.000000, 158.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <circle id="Oval" cx="6.72" cy="7.18" r="6.5" />
          <circle id="Oval" cx="24.22" cy="7.18" r="6.5" />
          <circle id="Oval" cx="41.72" cy="7.18" r="6.5" />
        </g>
        <rect
          id="Rectangle"
          fill="#FFFFFF"
          fillRule="nonzero"
          x="141.22"
          y="294.86"
          width="790"
          height="392.78"
          rx="10.19"
        />
        <rect
          id="Rectangle"
          fill="#5A5773"
          fillRule="nonzero"
          opacity="0.2"
          x="107.72"
          y="204.45"
          width="227.24"
          height="23.85"
          rx="3.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.2"
          x="536.22"
          y="340.45"
          width="227.24"
          height="23.85"
          rx="3.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.2"
          x="536.22"
          y="407.23"
          width="354.83"
          height="23.85"
          rx="3.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.2"
          x="536.22"
          y="446.23"
          width="354.83"
          height="23.85"
          rx="3.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.2"
          x="536.22"
          y="485.23"
          width="354.83"
          height="23.85"
          rx="3.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.2"
          x="536.22"
          y="524.23"
          width="354.83"
          height="23.85"
          rx="3.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.2"
          x="184.05"
          y="567.23"
          width="707"
          height="23.85"
          rx="3.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.2"
          x="184.05"
          y="606.23"
          width="707"
          height="23.85"
          rx="3.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.2"
          x="184.05"
          y="645.23"
          width="707"
          height="23.85"
          rx="3.86"
        />
        <path
          d="M729.3,661 C729.3,661 735.23,668.75 726.56,680.46 C717.89,692.17 710.75,702.05 713.64,709.35 C713.64,709.35 726.71,687.61 737.36,687.35 C748.01,687.09 741.01,674.07 729.3,661 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M729.3,661 C729.816397,661.748598 730.223803,662.566776 730.51,663.43 C740.9,675.63 746.43,687.02 736.45,687.3 C727.15,687.57 715.99,704.2 713.32,708.39 C713.403849,708.730209 713.510763,709.064315 713.64,709.39 C713.64,709.39 726.71,687.65 737.36,687.39 C748.01,687.13 741.01,674.07 729.3,661 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M740.32,670.88 C740.32,673.61 740.02,675.82 739.64,675.82 C739.26,675.82 738.96,673.61 738.96,670.88 C738.96,668.15 739.34,669.44 739.72,669.44 C740.1,669.44 740.32,668.15 740.32,670.88 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <path
          d="M744.11,674.14 C741.71,675.44 739.62,676.23 739.44,675.9 C739.26,675.57 741.06,674.24 743.44,672.9 C745.82,671.56 744.89,672.54 745.07,672.9 C745.25,673.26 746.5,672.83 744.11,674.14 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <path
          d="M697.98,661 C697.98,661 692.05,668.75 700.71,680.46 C709.37,692.17 716.53,702.05 713.64,709.35 C713.64,709.35 700.56,687.61 689.92,687.35 C679.28,687.09 686.27,674.07 697.98,661 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M697.98,661 C697.45759,661.746519 697.046616,662.565099 696.76,663.43 C686.38,675.63 680.85,687.02 690.83,687.3 C700.13,687.57 711.28,704.2 713.95,708.39 C713.869534,708.729997 713.76596,709.064106 713.64,709.39 C713.64,709.39 700.56,687.65 689.92,687.39 C679.28,687.13 686.27,674.07 697.98,661 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M686.95,670.88 C686.95,673.61 687.26,675.82 687.64,675.82 C688.02,675.82 688.32,673.61 688.32,670.88 C688.32,668.15 687.94,669.46 687.57,669.46 C687.2,669.46 686.95,668.15 686.95,670.88 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <path
          d="M683.17,674.14 C685.57,675.44 687.66,676.23 687.84,675.9 C688.02,675.57 686.22,674.24 683.84,672.9 C681.46,671.56 682.39,672.54 682.21,672.9 C682.03,673.26 680.77,672.83 683.17,674.14 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <ellipse
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="713.64"
          cy="759.15"
          rx="62"
          ry="9.51"
        />
        <path
          d="M745.57,698.9 L745.27,701.32 L744.86,704.74 L744.68,706.17 L744.27,709.59 L744.09,711.02 L743.67,714.43 L738.93,753.33 C738.5,756.8 732.83,759.51 725.93,759.51 L701.31,759.51 C694.46,759.51 688.8,756.8 688.38,753.33 L683.62,714.46 L683.21,711.05 L683.03,709.62 L682.61,706.2 L682.44,704.77 L682.02,701.35 L681.72,698.93 C681.49,696.93 684.56,695.31 688.43,695.31 L738.85,695.31 C742.72,695.28 745.79,696.93 745.57,698.9 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <polygon
          id="Path"
          fill="#9D9CB5"
          fillRule="nonzero"
          points="745.25 701.32 744.84 704.74 682.44 704.74 682.02 701.32"
        />
        <polygon
          id="Path"
          fill="#9D9CB5"
          fillRule="nonzero"
          points="744.66 706.16 744.25 709.58 683.03 709.58 682.61 706.16"
        />
        <polygon
          id="Path"
          fill="#9D9CB5"
          fillRule="nonzero"
          points="744.07 711.01 743.65 714.43 683.62 714.43 683.21 711.01"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.2"
          x="184.05"
          y="327.22"
          width="302"
          height="221.54"
          rx="8.5"
        />
        <path
          d="M1125.05,573.61 C1125.43,572.61 1122.61,566.89 1122.61,566.61 C1122.61,566.33 1119.7,563.16 1119.7,561.39 C1119.7,559.62 1115.85,555.79 1115.85,555.79 C1115.85,555.79 1110.68,553.65 1110.12,548.98 C1109.56,544.31 1103.93,544.23 1103.92,544.23 L1103.92,544.23 C1103.92,544.23 1103.92,543.81 1103.92,543.16 C1104.03403,541.31613 1103.79996,539.467273 1103.23,537.71 C1102.56626,536.42085 1101.41948,535.446627 1100.04,535 C1100.04,535 1099.47,531.36 1098.35,530.24 C1097.08023,528.910787 1096.58179,527.02276 1097.03,525.24 C1097.6,523.48 1096.28,519 1093.56,518.34 C1090.84,517.68 1087.73,516.66 1087.73,516.66 L1086.98,516.79 L1086.61,516.66 C1085.94942,516.786386 1085.28136,516.869894 1084.61,516.91 C1084.03565,516.926885 1083.47338,516.742999 1083.02,516.39 C1082.08,515.39 1074.47,513.39 1073.02,513.39 C1071.57,513.39 1067.57,511.52 1067.57,511.52 C1067.57,511.52 1064.75,509.38 1063.57,508.44 C1062.39,507.5 1060.34,504.09 1060.03,503.57 L1060.03,503.5 L1060.03,503.5 L1060.03,503.5 C1059.68559,502.705818 1059.40146,501.886837 1059.18,501.05 L1059.18,501.05 C1060.55496,499.611418 1061.72894,497.993407 1062.67,496.24 C1062.77,496.06 1062.86,495.88 1062.95,495.69 C1063.15665,495.690177 1063.3622,495.659851 1063.56,495.6 L1063.81,495.5 C1064.76602,495.003429 1065.48549,494.147257 1065.81,493.12 L1065.81,493.12 C1065.88052,492.916535 1065.9406,492.709598 1065.99,492.5 C1065.99,492.43 1065.99,492.36 1065.99,492.29 L1066.08,491.87 C1066.0752,491.790072 1066.0752,491.709928 1066.08,491.63 L1066.14,491.21 L1066.14,490.97 C1066.14,490.79 1066.14,490.62 1066.21,490.44 L1066.21,490.44 C1066.27055,489.768593 1066.36735,489.100952 1066.5,488.44 L1066.5,488.44 L1066.5,488.44 C1067.06,485.91 1068.59,483.77 1069.66,481.44 L1069.66,481.44 C1069.81,481.11 1069.96,480.77 1070.09,480.44 C1070.22,480.11 1070.35,479.69 1070.46,479.31 L1070.55,478.96 C1070.62,478.68 1070.68,478.4 1070.74,478.12 C1070.8,477.84 1070.74,477.87 1070.81,477.74 C1070.87,477.36 1070.92,476.97 1070.96,476.57 C1071.13813,474.338696 1070.79581,472.096504 1069.96,470.02 C1069.26,468.27 1068.21,466.69 1067.5,464.94 C1066.42,462.29 1066.13,459.28 1064.82,456.75 C1062.61386,452.510087 1057.65953,450.494477 1053.12,451.99 C1051.12,452.75 1049.3,454.22 1047.23,454.88 C1044.45,455.77 1041.49,455.1 1038.61,454.71 C1035.73,454.32 1032.61,454.27 1030.25,456.15 C1027.59,458.31 1026.87,462.37 1024.37,464.74 C1023.37,465.74 1022.02,466.37 1020.91,467.29 C1020.12959,467.915361 1019.52915,468.736656 1019.17,469.67 L1019.11,469.86 C1019.08416,469.941824 1019.06411,470.025363 1019.05,470.11 C1019.02765,470.202228 1019.01095,470.295736 1019,470.39 C1018.99457,470.453217 1018.99457,470.516783 1019,470.58 C1018.97999,470.746066 1018.97999,470.913934 1019,471.08 L1019,471.08 C1019.01353,471.237971 1019.03691,471.394942 1019.07,471.55 L1019.07,471.68 C1019.07,471.81 1019.14,471.94 1019.19,472.07 C1019.24,472.2 1019.19,472.12 1019.19,472.14 C1019.19,472.16 1019.3,472.43 1019.36,472.57 L1019.45,472.78 C1019.45,472.84 1019.45,472.9 1019.53,472.95 C1019.88748,473.644419 1020.17876,474.37096 1020.4,475.12 C1020.51567,475.594768 1020.48428,476.093481 1020.31,476.55 C1020.07282,477.069639 1019.73262,477.535718 1019.31,477.92 C1017.43883,479.863047 1015.99459,482.175865 1015.07,484.71 C1014.95667,485.003333 1014.85667,485.293333 1014.77,485.58 L1014.77,485.58 L1014.9,485.58 C1015.16878,485.656767 1015.44286,485.713588 1015.72,485.75 C1015.87653,485.759212 1016.03347,485.759212 1016.19,485.75 C1016.83337,485.788061 1017.47895,485.740987 1018.11,485.61 L1018.59,485.49 C1019.24339,485.319515 1019.87947,485.088517 1020.49,484.8 C1020.49,484.99 1020.49,485.18 1020.49,485.37 C1020.49,485.56 1020.49,485.58 1020.49,485.69 C1020.50247,494.107177 1025.27836,501.791989 1032.82,505.53 C1032.82,505.73 1032.87,505.93 1032.9,506.13 L1032.96,506.64 L1032.71,506.4 C1032.71,506.4 1031.02,505.56 1029.42,507.98 C1028.2465,509.567949 1026.65353,510.797301 1024.82,511.53 C1024.82,511.53 1007.72,514.23 1007.06,516.47 L999.06,516.94 C999.06,516.94 996.24,517.31 995.96,523.19 C995.68,529.07 994.18,529.62 994.18,529.62 C994.18,529.62 990.89,535.41 991.18,538.39 C991.25198,540.244316 990.268141,541.979592 988.64,542.87 L988.27,548.19 C988.27,548.19 985.17,547.72 984.27,551.36 C983.911983,553.287404 983.110909,555.105226 981.93,556.67 C981.93,556.67 976.76,560.97 976.48,564.6 L973.28,566.6 C973.28,566.6 965.86,564.92 964.17,561.94 C964.17,561.94 963.97,561.74 963.65,561.45 L963.65,561.38 L963.65,561.38 C962.54,560.38 960.19,558.14 960.55,558.65 C960.770993,559.117877 960.823968,559.647627 960.7,560.15 L960.15,559.54 L958.67,557.9 C958.67,557.9 946.67,546.66 939.67,545.77 L939.67,545.77 C939.58,545.59 939.12,543.77 937.92,544.92 C935.911652,546.764697 934.762745,549.362787 934.749461,552.089726 C934.736178,554.816664 935.859719,557.425825 937.85,559.29 L949.09,569.78 L949.38,569.99 L951.79,573.09 C951.38,574.09 951.04,575.01 950.79,575.87 L950.79,575.96 L950.61,576.5 C950.58872,576.558622 950.572003,576.618801 950.56,576.68 C950.5,576.86 950.45,577.03 950.4,577.2 L950.31,577.5 C950.31,577.56 950.31,577.62 950.31,577.68 C950.04,578.62 949.87,579.34 949.79,579.74 L949.16,579.54 L949.77,579.81 L949.77,579.9 C949.77,580.03 949.77,580.1 949.77,580.1 L950.35,580.35 C953.64,581.78 970.06,588.99 970.9,590.08 C971.74,591.17 978.04,594.84 983.68,591.85 C989.32,588.86 990.53,584.3 990.53,584.3 C990.53,584.3 995.98,576.74 996.17,575.62 C996.36,574.5 1000.58,573.2 1000.58,573.2 C1000.58,573.2 1000.96,585.69 998.8,590.27 C996.64,594.85 992.6,615.08 992.6,615.08 C992.86535,615.04252 993.13465,615.04252 993.4,615.08 L993.16,616.25 C993.490469,616.188199 993.829531,616.188199 994.16,616.25 C993.86,618.55 992.16,629.25 992.16,629.25 C992.16,629.25 991.6,634.1 990.66,635.78 C989.72,637.46 989.66,646.23 989.66,646.23 L988.15,652.57 C988.15,652.57 988.35,653.01 988.72,653.66 L988.72,653.66 C989.732067,655.817939 991.207005,657.726481 993.04,659.25 C992.919461,660.24668 992.663779,661.222307 992.28,662.15 C991.69644,663.567977 991.440084,665.099276 991.53,666.63 C991.53,666.63 989.94,673.81 990.12,675.86 C990.3,677.91 989.12,682.95 989.12,682.95 L987.43,699.18 C987.43,699.18 986.31,713.26 986.87,717.09 C987.138719,720.09368 987.010955,723.119662 986.49,726.09 C986.49,726.09 987.62,737.19 987.34,738.4 C987.06,739.61 985.65,744.84 986.49,747.73 C987.33,750.62 986.87,758.55 986.87,758.55 C986.87,758.55 987.43,769 988.09,772.36 C988.442548,774.903396 988.378374,777.487241 987.9,780.01 C987.9,780.01 987.24,787.19 986.96,787.19 C986.68,787.19 984.24,792.13 989.21,796.98 C994.18,801.83 991.1,801.08 991.1,801.08 C991.1,801.08 987.1,799.08 987.62,803.14 C988.06,806.95 988.68,805.96 988.74,805.85 L987.8,808.92 L988.46,809.01 L987.92,809.66 C987.353806,810.387379 986.717406,811.057273 986.02,811.66 C985.288556,812.374758 984.853003,813.338687 984.8,814.36 C984.8,814.36 977.85,821.92 971.37,825.74 C967.96,827.74 965.02,829.45 963.74,830.87 C962.58,832.13 962.74,833.15 965.17,833.95 C970.24,835.63 979.17,836.47 985.55,834.32 C989.372855,833.055552 992.813163,830.843434 995.55,827.89 C995.55,827.89 999.55,825.83 1003.55,826.58 C1007.55,827.33 1015.39,822.2 1015.39,822.2 L1015.24,820.88 L1014.83,817.06 C1014.29511,816.413061 1014.05573,815.571613 1014.17,814.74 C1014.21889,813.610045 1014.10779,812.478852 1013.84,811.38 C1013.77,811.01 1013.7,810.64 1013.63,810.3 L1014.35,810.16 C1014.35,810.16 1013.42,805.41 1015.11,804.47 C1016.8,803.53 1016.32,791.32 1016.32,791.32 C1016.32,791.32 1014.17,788.52 1013.04,788.06 C1011.91,787.6 1012.94,781.8 1013.14,781.06 C1013.34,780.32 1014.83,765.85 1014.83,765.85 C1014.83,765.85 1014.26,761.29 1015.01,759.33 C1015.76,757.37 1014.07,749.81 1014.07,749.81 C1013.74923,749.098587 1013.94135,748.260619 1014.54,747.76 C1015.54,746.64 1015.2,736.66 1015.2,736.66 C1015.2,736.66 1015.11,731.66 1015.11,730.31 C1015.11,728.96 1016.23,724.25 1017.27,722.67 C1018.31,721.09 1017.64,716.14 1017.64,716.14 L1017.64,716.14 L1017.7,715.77 C1017.7,715.63 1017.7,715.45 1017.78,715.24 L1017.86,714.74 C1018.3184,712.007127 1018.93273,709.30271 1019.7,706.64 C1020.92,702.73 1022.33,695.83 1022.33,695.83 L1031.06,673.05 L1031.16,672.78 C1031.16,672.78 1035.16,680.24 1035.16,687.15 C1035.16,687.15 1036.16,695.45 1035.92,697.69 C1035.68,699.93 1036.57,710.46 1036.57,710.46 C1036.57,710.46 1037.79,725.57 1037.79,726.22 C1037.79,726.87 1039.3,738.53 1040.24,740.31 C1041.18,742.09 1039.3,747.49 1038.73,748.05 C1038.16,748.61 1038.92,762.32 1038.92,762.32 C1038.92,762.32 1037.51,773.14 1037.23,775.38 C1036.95,777.62 1035.82,786.2 1036.76,789.56 C1037.7,792.92 1037.32,793.38 1037.32,793.38 C1037.32,793.38 1040.71,796.84 1038.73,797.12 C1037.27655,797.438 1036.03055,798.366759 1035.3106,799.668801 C1034.59064,800.970844 1034.46653,802.519939 1034.97,803.92 C1036.14726,807.333703 1037.52978,810.673126 1039.11,813.92 L1040.67,813.59 L1040.67,814.7 L1040.78,820.26 C1040.78,820.26 1041.44,825.57 1041.06,826.79 C1040.79,827.67 1040.41,831.85 1040.23,834.04 C1040.16,834.84 1040.12,835.37 1040.12,835.37 C1040.12,835.37 1040.12,840.31 1050.55,838.82 C1060.98,837.33 1062.85,833.22 1062.85,833.22 L1062.93,832.71 C1063.08,831.77 1063.42,829.77 1063.7,828.65 C1064.07,827.16 1060.7,820.44 1060.7,820.44 C1060.7,820.44 1060.14,815.87 1059.2,814.85 C1058.80533,814.245979 1058.54606,813.563694 1058.44,812.85 C1058.36,812.47 1058.28,812.08 1058.22,811.7 C1058.45527,811.727743 1058.68892,811.767798 1058.92,811.82 C1058.92,811.82 1058.35,808.56 1060.52,807.53 C1062.69,806.5 1062.11,804.36 1061.83,803.43 C1061.55,802.5 1062.67,797.27 1062.67,797.27 C1062.34565,796.208259 1062.63417,795.054197 1063.42,794.27 C1064.74,792.96 1065.77,783.82 1065.77,783.82 L1065.96,748.56 C1065.96,748.56 1066.62,742.31 1065.87,739.79 C1065.12,737.27 1064.37,732.42 1065.4,731.11 C1066.43,729.8 1065.49,723.75 1065.49,723.75 C1065.49,723.75 1065.49,710.97 1066.9,707.75 C1068.31,704.53 1067.84,684.52 1067.84,684.52 L1068.21,671.37 C1068.21,671.37 1071.28,668.47 1070.56,653.37 C1073.83,653.16 1077.56,653.04 1078.08,653.5 C1079.08,654.34 1085.78,658.63 1089.73,655.92 C1091.36075,654.799702 1092.9266,653.587753 1094.42,652.29 L1092.76,624.29 C1093.76,625.85 1094.42,626.88 1094.42,626.88 C1094.42,622.97 1105.51,610.28 1105.51,610.28 C1105.51,610.28 1115.84,596.94 1118.09,595.36 C1120.34,593.78 1124.76,585.36 1124.76,585.36 C1125.41336,583.76014 1126.16823,582.203639 1127.02,580.7 C1128.06,579.11 1124.68,574.63 1125.05,573.61 Z M1100.82,583.4 C1098,583.68 1092.08,590.12 1091.99,591.52 C1091.78491,592.443323 1091.3556,593.301935 1090.74,594.02 C1090.74,593.46 1090.65,592.89 1090.6,592.31 C1089.94,584.06 1089.22,574.02 1089.6,573.05 C1090.16,571.37 1089.97,563.81 1089.97,563.81 L1089.97,563.81 L1090.08,563.66 C1091.97,569.52 1097.85,576.42 1097.85,576.42 C1097.85,576.42 1098.85,579.42 1100.11,579.49 C1101.37,579.56 1100.82,583.4 1100.82,583.4 L1100.82,583.4 Z"
          id="Shape"
          fill="url(#linearGradient-2)"
          fillRule="nonzero"
        />
        <path
          d="M950.22,581.27 C950.22,581.27 953.65,563.27 964.66,563.27 L972.72,579.84 L967.35,583.54 C967.35,583.54 955.68,583.86 950.22,581.27 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <path
          d="M972.72,579.79 L967.35,583.49 C967.35,583.49 959.14,583.75 953.27,582.31 C952.222806,582.0782 951.201151,581.743231 950.22,581.31 L950.28,581.02 L950.28,580.96 C950.781374,578.704045 951.477311,576.495783 952.36,574.36 C952.7,573.55 953.08,572.72 953.5,571.89 C955.11,568.79 957.38,565.74 960.5,564.24 C961.643308,563.662401 962.891715,563.322235 964.17,563.24 L964.66,563.24 L964.84,563.61 L967.56,569.21 L972.72,579.79 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1064.18,654.4 C1064.18,654.4 1075.75,653.29 1076.77,654.13 C1077.79,654.97 1084.36,659.22 1088.24,656.53 C1092.12,653.84 1089.54,644.53 1089.54,644.13 C1089.54,643.73 1089.17,630.52 1089.17,630.52 L1082.23,621.17 L1073.53,604.79 L1055.75,603.03 L1056.21,629.03 L1056.12,642.36 L1064.18,654.4 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <path
          d="M1064.18,654.4 C1064.18,654.4 1075.75,653.29 1076.77,654.13 C1077.79,654.97 1084.36,659.22 1088.24,656.53 C1092.12,653.84 1089.54,644.53 1089.54,644.13 C1089.54,643.73 1089.17,630.52 1089.17,630.52 L1082.23,621.17 L1073.53,604.79 L1055.75,603.03 L1056.21,629.03 L1056.12,642.36 L1064.18,654.4 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M962.35,562.76 C962.35,562.76 961.42,574.05 954.35,574.24 C954.35,574.24 952.35,573.04 949.67,571.03 C943.49,566.4 933.67,557.51 936.39,549.24 C940.28,537.39 959.16,559.24 959.16,559.24 L960.62,560.87 L962.35,562.76 Z"
          id="Path"
          fill="#FBBEBE"
          fillRule="nonzero"
        />
        <path
          d="M962.35,562.76 C962.35,562.76 961.42,574.05 954.35,574.24 C954.35,574.24 952.35,573.04 949.67,571.03 L949.07,570.26 C950.268206,570.871204 951.585747,571.212536 952.93,571.26 C955.093438,571.344896 957.083909,570.082938 957.93,568.09 C958.68808,566.635748 959.356008,565.136251 959.93,563.6 C960.26059,562.70332 960.498498,561.775146 960.64,560.83 L962.35,562.76 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M959.29,583.22 L957.71,581.22 L952.38,574.36 L949.67,570.85 C950.86424,571.462241 952.178768,571.803676 953.52,571.85 C955.685791,571.943675 957.680845,570.678811 958.52,568.68 C959.262572,567.22869 959.913838,565.732448 960.47,564.2 C961.35,561.7 961.33,560.42 961.02,559.98 C960.71,559.54 963.02,561.66 964.08,562.7 L964.08,562.7 L964.59,563.18 L964.78,563.56 L967.57,568.96 C967.57609,569.036546 967.57609,569.113454 967.57,569.19 C967.77,570.89 968.67,581.68 959.29,583.22 Z"
          id="Path"
          fill="#E7EFFD"
          fillRule="nonzero"
        />
        <path
          d="M1014.75,821.46 C1014.75,821.46 1006.97,826.56 1003.08,825.81 C1000.38611,825.471018 997.651772,825.922688 995.21,827.11 C992.535426,830.038186 989.159399,832.237249 985.4,833.5 C979.1,835.63 970.31,834.79 965.31,833.13 C962.95,832.34 962.76,831.32 963.9,830.07 C965.04,828.82 968.06,826.98 971.42,824.98 C977.81,821.18 984.66,813.69 984.66,813.69 C984.703276,812.673338 985.132399,811.711387 985.86,811 C986.548092,810.396972 987.174508,809.727009 987.73,809 C988.73,807.83 989.66,806.6 989.66,806.6 L1012.57,807.46 C1012.57,807.46 1012.96,809.11 1013.27,810.8 C1013.53059,811.889787 1013.63829,813.010531 1013.59,814.13 C1013.47586,814.956897 1013.71139,815.793963 1014.24,816.44 L1014.65,820.22 L1014.75,821.46 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <path
          d="M1062.57,827.88 C1062.3,828.99 1061.96,830.97 1061.81,831.88 C1061.81,832.19 1061.74,832.39 1061.74,832.39 C1061.74,832.39 1059.89,836.46 1049.61,837.94 C1039.33,839.42 1039.34,834.52 1039.34,834.52 L1039.44,833.19 C1039.62,831.03 1039.99,826.88 1040.26,826 C1040.63,824.8 1039.99,819.52 1039.99,819.52 L1039.88,814 L1039.8,810.17 L1056.8,808.41 C1056.90936,809.682967 1057.09301,810.948457 1057.35,812.2 C1057.44892,812.913953 1057.70508,813.597049 1058.1,814.2 C1059.02,815.2 1059.58,819.75 1059.58,819.75 C1059.58,819.75 1062.97,826.4 1062.57,827.88 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <path
          d="M1012.57,807.46 C1012.57,807.46 1012.96,809.11 1013.27,810.8 C1010.8,811.25 1000,813.12 997.27,811.8 C994.21,810.32 987.64,809.49 987.64,809.49 L987.75,809.11 C988.75,807.94 989.68,806.71 989.68,806.71 L1012.57,807.46 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1057.41,812.23 C1053.1,811.5 1043.63,813.23 1039.91,814.03 L1039.83,810.2 L1056.83,808.44 C1056.94927,809.713562 1057.14293,810.979057 1057.41,812.23 L1057.41,812.23 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1067.04,671.9 L1066.68,684.9 C1066.68,684.9 1067.14,704.8 1065.75,707.9 C1064.36,711 1064.36,723.73 1064.36,723.73 C1064.36,723.73 1065.29,729.73 1064.27,731.04 C1063.25,732.35 1063.99,737.15 1064.73,739.65 C1065.47,742.15 1064.82,748.35 1064.82,748.35 L1064.64,783.35 C1064.64,783.35 1063.64,792.42 1062.32,793.72 C1061.54756,794.511817 1061.26439,795.659798 1061.58,796.72 C1061.58,796.72 1060.47,801.9 1060.75,802.83 C1061.03,803.76 1061.58,805.88 1059.46,806.9 C1057.34,807.92 1057.88,811.16 1057.88,811.16 C1052.79,809.95 1038.35,813.16 1038.35,813.16 C1036.79123,809.942041 1035.42874,806.632652 1034.27,803.25 C1033.76575,801.862193 1033.88395,800.324407 1034.59437,799.029962 C1035.30478,797.735517 1036.53851,796.809953 1037.98,796.49 C1039.92,796.22 1036.59,792.79 1036.59,792.79 C1036.59,792.79 1036.96,792.33 1036.03,788.99 C1035.1,785.65 1036.22,777.14 1036.5,774.92 C1036.78,772.7 1038.16,761.92 1038.16,761.92 C1038.16,761.92 1037.42,748.31 1037.98,747.76 C1038.54,747.21 1040.38,741.83 1039.46,740.08 C1038.54,738.33 1037.05,726.75 1037.05,726.08 C1037.05,725.41 1035.85,710.43 1035.85,710.43 C1035.85,710.43 1034.74,699.97 1035.02,697.75 C1035.3,695.53 1034.27,687.29 1034.27,687.29 C1034.27,680.44 1030.27,673.03 1030.27,673.03 L1030.17,673.3 L1021.57,696.06 C1021.57,696.06 1020.18,702.91 1018.98,706.8 C1018.22203,709.429308 1017.61768,712.100488 1017.17,714.8 L1017.09,715.3 L1017.01,715.82 L1016.95,716.19 L1016.95,716.19 C1016.95,716.19 1017.59,721.09 1016.57,722.67 C1015.434,725.059965 1014.71691,727.627284 1014.45,730.26 C1014.45,731.56 1014.54,736.56 1014.54,736.56 C1014.54,736.56 1014.91,746.46 1013.89,747.56 C1013.31511,748.053924 1013.12867,748.864546 1013.43,749.56 C1013.43,749.56 1015.09,757.06 1014.35,759 C1013.61,760.94 1014.17,765.48 1014.17,765.48 C1014.17,765.48 1012.69,779.83 1012.5,780.57 C1012.31,781.31 1011.3,787.05 1012.41,787.51 C1013.52,787.97 1015.65,790.75 1015.65,790.75 C1015.65,790.75 1016.11,802.88 1014.45,803.8 C1012.79,804.72 1013.7,809.45 1013.7,809.45 C1013.7,809.45 1000.28,812.04 997.23,810.56 C994.18,809.08 987.6,808.25 987.6,808.25 L988.52,805.25 C988.46,805.36 987.85,806.35 987.42,802.56 C986.95,798.56 990.84,800.56 990.84,800.56 C990.84,800.56 993.9,801.3 988.99,796.49 C984.08,791.68 986.49,786.77 986.77,786.77 C987.05,786.77 987.69,779.64 987.69,779.64 C988.163077,777.136891 988.227243,774.573644 987.88,772.05 C987.23,768.72 986.68,758.35 986.68,758.35 C986.68,758.35 987.14,750.48 986.3,747.61 C985.46,744.74 986.86,739.61 987.14,738.35 C987.42,737.09 986.3,726.13 986.3,726.13 C986.822114,723.159788 986.949884,720.133652 986.68,717.13 C986.12,713.33 987.23,699.35 987.23,699.35 L988.9,683.25 C988.9,683.25 990.1,678.25 989.9,676.25 C989.7,674.25 991.29,667.09 991.29,667.09 C991.200084,665.569955 991.452984,664.049139 992.03,662.64 C992.96,660.79 993.33,654.64 993.33,654.64 L1002.22,634.28 L1006.57,616.28 L1065.35,615.72 C1065.35,615.72 1065.56,617.28 1065.92,620.11 C1066.28,622.94 1066.78,627.11 1067.34,632.3 C1067.85,637 1068.41,642.53 1068.96,648.68 C1070.75,668.38 1067.04,671.9 1067.04,671.9 Z"
          id="Path"
          fill="#3F3D56"
          fillRule="nonzero"
        />
        <path
          d="M1061.57,509.81 L1047.88,524.46 C1047.88,524.46 1030.3,517.46 1032.15,515.01 C1032.86,514.08 1032.75,511.14 1032.34,507.9 C1031.69,502.77 1030.34,496.9 1030.34,496.9 C1030.34,496.9 1061.07,491.9 1058.47,497.08 C1057.64281,499.034764 1057.57505,501.227902 1058.28,503.23 C1059.02115,505.58378 1060.13166,507.804815 1061.57,509.81 L1061.57,509.81 Z"
          id="Path"
          fill="#FBBEBE"
          fillRule="nonzero"
        />
        <path
          d="M1058.43,497.03 C1057.49,498.93 1057.04,499.11 1057.63,501.15 C1053.63,505.46 1048.5,510.15 1042.14,510.15 C1038.73914,510.153943 1035.38401,509.366515 1032.34,507.85 C1031.69,502.72 1030.34,496.85 1030.34,496.85 C1030.34,496.85 1061.03,491.85 1058.43,497.03 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1064.18,487.59 C1064.18,499.759594 1054.31459,509.625 1042.145,509.625 C1029.97541,509.625 1020.11,499.759594 1020.11,487.59 C1020.11,487.48 1020.11,487.38 1020.11,487.27 C1020.19837,475.103167 1030.13317,465.311634 1042.3,465.4 C1054.46683,465.488366 1064.25837,475.423167 1064.17,487.59 L1064.18,487.59 Z"
          id="Path"
          fill="#FBBEBE"
          fillRule="nonzero"
        />
        <path
          d="M1067.37,632.94 C1064.45,632.94 1054.73,633.04 1043.87,633.22 L1043.74,633.22 L1040.15,633.28 L1040.04,633.28 C1027.16,633.48 1014.47,630.97 1009.37,631.44 C998.54,632.44 1013.26,621.44 1013.26,621.44 C1021.33085,623.393803 1029.63151,624.231608 1037.93,623.93 L1041.05,623.77 C1050.89,623.21 1060.78,622.29 1065.95,620.77 C1066.31,623.61 1066.81,627.77 1067.37,632.94 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1067.37,632.38 C1064.45,632.38 1054.73,632.49 1043.87,632.66 L1043.74,632.66 L1040.15,632.72 L1040.04,632.72 C1027.16,632.93 1014.47,630.41 1009.37,630.89 C998.54,631.89 1013.26,620.89 1013.26,620.89 C1021.32987,622.849558 1029.63132,623.687443 1037.93,623.38 L1041.05,623.22 C1050.89,622.67 1060.78,621.74 1065.95,620.22 C1066.31,623.05 1066.81,627.21 1067.37,632.38 Z"
          id="Path"
          fill="#5F5D7E"
          fillRule="nonzero"
        />
        <path
          d="M1036.22,515.92 L1019.22,523.92 L1006.07,625.56 C1006.07,625.56 1013.85,622.04 1018.29,624.26 C1022.73,626.48 1036.43,624.45 1036.43,624.45 C1036.43,624.45 1046.43,623.89 1047.91,625.01 C1049.39,626.13 1066.8,620.38 1066.8,620.38 C1066.8,620.38 1069.95,613.38 1067.54,612.23 C1065.13,611.08 1068.28,600.23 1068.28,600.23 L1066.8,526.91 L1063.8,517.47 L1055.8,512.65 L1047.66,519.13 L1043.77,519.69 L1036.22,515.92 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1036.22,514.81 L1019.22,522.81 L1006.04,624.46 C1006.04,624.46 1013.82,620.94 1018.26,623.16 C1022.7,625.38 1036.4,623.35 1036.4,623.35 C1036.4,623.35 1046.4,622.79 1047.88,623.9 C1049.36,625.01 1066.77,619.28 1066.77,619.28 C1066.77,619.28 1069.92,612.28 1067.51,611.13 C1065.1,609.98 1068.25,599.13 1068.25,599.13 L1066.77,525.81 L1063.77,516.37 L1055.77,511.55 L1047.63,518.03 L1043.74,518.59 L1036.22,514.81 Z"
          id="Path"
          fill="#E7EFFD"
          fillRule="nonzero"
        />
        <path
          d="M1035.94,519.53 C1035.94,519.53 1040.85,525.36 1040.76,526.53 C1040.67,527.7 1040.48,530.61 1040.48,530.61 L1036.78,538.1 C1036.78,538.1 1034.78,547.45 1034.78,549.4 C1034.78,551.35 1031.54,568.19 1031.54,568.19 L1027.57,594.14 L1022.66,628.14 L1027.66,636.75 L1033.59,631.75 L1041.46,571.21 L1043.12,559.27 C1043.12,559.27 1044.88,537.79 1044.88,535.57 C1044.69126,532.870676 1044.35744,530.18346 1043.88,527.52 C1043.88,527.52 1045.09,521.96 1050.09,520.67 C1055.09,519.38 1049.71,520.39 1049.71,520.39 L1046.85,518.08 L1044.35,519.08 C1044.35,519.08 1037.42,516.94 1035.94,519.53 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1035.39,518.97 C1035.39,518.97 1040.29,524.8 1040.2,525.97 C1040.11,527.14 1039.92,530.04 1039.92,530.04 L1036.22,537.54 C1036.22,537.54 1034.22,546.89 1034.22,548.83 C1034.22,550.77 1030.98,567.62 1030.98,567.62 L1027.1,593.54 L1022.19,627.54 L1027.19,636.15 L1033.11,631.15 L1040.98,570.61 L1042.65,558.67 C1042.65,558.67 1044.41,537.19 1044.41,534.97 C1044.22108,532.26738 1043.88727,529.576845 1043.41,526.91 C1043.41,526.91 1044.61,521.36 1049.61,520.06 C1054.61,518.76 1049.24,519.79 1049.24,519.79 L1046.37,517.47 L1043.87,518.47 C1043.87,518.47 1036.87,516.38 1035.39,518.97 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M1032.15,509.25 C1032.15,509.25 1031.41,509.81 1031.22,513.51 C1031.03,517.21 1028.44,525.51 1028.44,525.51 C1028.44,525.51 1038.07,518.85 1042.88,519.59 L1032.15,509.25 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1032.15,508.14 C1032.15,508.14 1031.41,508.7 1031.22,512.4 C1031.03,516.1 1028.44,524.4 1028.44,524.4 C1028.44,524.4 1038.07,517.74 1042.88,518.48 L1032.15,508.14 Z"
          id="Path"
          fill="#E7EFFD"
          fillRule="nonzero"
        />
        <path
          d="M1058.44,506.29 L1043.26,519.62 C1043.26,519.62 1056.03,527.21 1057.7,529.06 C1059.37,530.91 1061.03,510.92 1061.03,510.92 L1058.44,506.29 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1058.99,505.18 L1043.81,518.51 C1043.81,518.51 1056.59,526.1 1058.25,527.95 C1059.91,529.8 1061.58,509.81 1061.58,509.81 L1058.99,505.18 Z"
          id="Path"
          fill="#E7EFFD"
          fillRule="nonzero"
        />
        <path
          d="M1032.7,509.25 C1032.7,509.25 1031.04,508.42 1029.46,510.83 C1028.30658,512.399267 1026.73758,513.614985 1024.93,514.34 C1024.93,514.34 1008.08,517.03 1007.43,519.25 L999.56,519.71 C999.56,519.71 996.78,520.08 996.56,525.92 C996.34,531.76 994.8,532.3 994.8,532.3 C994.8,532.3 991.56,538.04 991.8,541 C991.872997,542.836207 990.906176,544.557149 989.3,545.45 L1000.87,575.53 C1000.87,575.53 1001.24,587.94 999.11,592.47 C996.98,597 993,617.1 993,617.1 C993,617.1 994.67,616.73 994.57,617.84 C994.47,618.95 992.57,631.08 992.57,631.08 C992.57,631.08 992.01,635.89 991.09,637.56 C990.17,639.23 990.09,647.92 990.09,647.92 L988.61,654.22 C988.61,654.22 992.12,662.09 997.49,660.98 C1002.86,659.87 1012.57,638.85 1012.57,638.85 L1018.77,616.17 L1023.59,593.77 L1024.98,578.59 L1027.2,544.98 L1030.44,522.77 C1030.44,522.77 1034,510.83 1032.7,509.25 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1032.15,508.14 C1032.15,508.14 1030.48,507.31 1028.91,509.72 C1027.75157,511.288497 1026.17964,512.503804 1024.37,513.23 C1024.37,513.23 1007.52,515.92 1006.87,518.14 L999.01,518.6 C999.01,518.6 996.23,518.97 995.95,524.8 C995.67,530.63 994.19,531.19 994.19,531.19 C994.19,531.19 990.95,536.93 991.19,539.89 C991.267716,541.727339 990.299597,543.45059 988.69,544.34 L1000.3,574.46 C1000.3,574.46 1000.67,586.87 998.54,591.4 C996.41,595.93 992.43,616.03 992.43,616.03 C992.43,616.03 994.1,615.66 994.01,616.77 C993.92,617.88 992.01,630 992.01,630 C992.01,630 991.46,634.82 990.53,636.48 C989.6,638.14 989.53,646.85 989.53,646.85 L988.05,653.15 C988.05,653.15 991.57,661.02 996.94,659.9 C1002.31,658.78 1012.03,637.78 1012.03,637.78 L1018.23,615.1 L1023.04,592.7 L1024.37,577.46 L1026.59,543.85 L1029.83,521.64 C1029.83,521.64 1033.44,509.72 1032.15,508.14 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <path
          d="M972.72,579.79 L967.35,583.49 C967.35,583.49 959.14,583.75 953.27,582.31 L950.27,580.98 L949.67,580.72 L950.29,580.92 C952.673962,581.769391 955.262367,581.860212 957.7,581.18 C965.3,578.62 964.46,566.08 964.16,563.24 C964.16,562.95 964.11,562.77 964.1,562.7 L964.1,562.7 L964.1,562.77 C964.206716,562.940217 964.323595,563.103847 964.45,563.26 L964.79,563.62 L964.79,563.62 L967.57,568.96 C967.57609,569.036546 967.57609,569.113454 967.57,569.19 L972.72,579.79 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M991.32,543.6 L988.73,544.34 L988.36,549.61 C988.36,549.61 985.36,549.15 984.47,552.76 C984.114447,554.673659 983.324132,556.480094 982.16,558.04 C982.16,558.04 977.07,562.3 976.79,565.91 L973.64,567.85 C973.64,567.85 966.33,566.18 964.64,563.22 C964.64,563.22 967.98,587.1 950.2,581.22 C950.2,581.22 970.1,589.92 971.03,591.13 C971.96,592.34 978.03,595.85 983.62,592.89 C989.21,589.93 990.38,585.39 990.38,585.39 C990.38,585.39 995.75,577.89 995.93,576.78 C996.11,575.67 1000.28,574.37 1000.28,574.37 L1008.28,555.12 L991.32,543.6 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <path
          d="M1056.31,517.4 L1058.99,505.18 C1058.99,505.18 1060.2,509.18 1061.4,510.09 L1065.4,513.09 C1065.4,513.09 1069.4,514.94 1070.77,514.94 C1072.14,514.94 1079.66,516.94 1080.58,517.94 C1081.5,518.94 1085.21,518.22 1085.21,518.22 C1085.21,518.22 1088.26,519.22 1090.95,519.89 C1093.64,520.56 1094.95,524.98 1094.37,526.74 C1093.91659,528.519322 1094.40735,530.406853 1095.67,531.74 C1096.78,532.85 1097.34,536.46 1097.34,536.46 C1098.69921,536.904149 1099.82784,537.867435 1100.48,539.14 C1101.41,541.14 1101.13,545.62 1101.13,545.62 L1087.34,565.06 C1087.34,565.06 1087.52,572.56 1086.97,574.23 C1086.42,575.9 1088.91,604.23 1088.91,604.23 L1091.78,652.92 C1090.30797,654.212086 1088.76202,655.417455 1087.15,656.53 C1086.32,656.9 1085.49,639.31 1085.49,638.67 C1085.49,638.03 1064.1,606.67 1064.1,606.67 C1064.1,606.67 1061.23,602.04 1061.23,601.02 C1061.23,600 1058.55,590.65 1058.55,590.65 L1054.48,572.65 L1056.31,517.4 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1102.26,544.57 C1102.26,545.21 1102.26,545.63 1102.26,545.63 L1088.48,565.05 L1088.48,565.05 C1088.48,565.05 1088.67,572.55 1088.11,574.22 C1087.79,575.22 1088.49,585.15 1089.11,593.33 C1089.58,599.23 1090.01,604.21 1090.01,604.21 L1091.23,624.86 L1092.88,652.86 C1091.40797,654.152086 1089.86202,655.357455 1088.25,656.47 C1087.42,656.84 1086.59,639.25 1086.59,638.6 C1086.59,637.95 1065.2,606.6 1065.2,606.6 C1065.2,606.6 1062.33,601.97 1062.33,600.95 C1062.33,599.93 1059.65,590.58 1059.65,590.58 L1055.58,572.58 L1057.43,517.41 L1059,505.19 C1059,505.19 1061.32,509.19 1062.52,510.09 L1066.52,513.15 C1066.52,513.15 1070.52,515 1071.89,515 C1073.26,515 1080.78,517 1081.7,518 C1082.62,519 1086.33,518.28 1086.33,518.28 C1086.33,518.28 1089.39,519.28 1092.07,519.95 C1094.75,520.62 1096.07,525.04 1095.49,526.8 C1095.03854,528.579317 1095.52905,530.465908 1096.79,531.8 C1097.9,532.91 1098.46,536.52 1098.46,536.52 C1099.81921,536.964149 1100.94784,537.927435 1101.6,539.2 C1102.14367,540.935199 1102.36731,542.754792 1102.26,544.57 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <path
          d="M989.1,791.22 C989.56,791.22 1009,791.96 1008.63,795.11 C1008.26,798.26 989.1,791.22 989.1,791.22 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M993.45,796.46 C993.45,796.46 1006.5,798.59 1003.08,800.53 C999.66,802.47 993.45,796.46 993.45,796.46 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1041.96,789.19 C1041.96,789.19 1063.62,791.04 1060.38,793.44 C1057.14,795.84 1049.46,796.22 1049.09,796.31 C1048.72,796.4 1041.96,789.19 1041.96,789.19 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1039.37,798.72 C1039.37,798.72 1051.37,800.72 1051.77,803.07 C1052.17,805.42 1039.37,798.72 1039.37,798.72 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1046.03,742.99 C1046.03,742.99 1057.03,745.58 1057.7,747.34 L1046.03,742.99 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1003.57,750.95 C1003.57,750.95 997.83,752.62 1003.39,755.95 C1008.95,759.28 1003.57,750.95 1003.57,750.95 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1029,661.99 C1029.65,661.99 1039.74,658.66 1043.26,660.14 C1045.77592,661.079794 1048.43458,661.580407 1051.12,661.62 L1029,661.99 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1030.3,672.54 L1030.2,673.46 L1021.57,696.06 C1021.57,696.06 1020.18,702.91 1018.98,706.8 C1018.22203,709.429308 1017.61768,712.100488 1017.17,714.8 L1024.81,667.43 L1030.3,672.54 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <polygon
          id="Path"
          fill="#3F3D56"
          fillRule="nonzero"
          points="1043.74 632.66 1040.15 632.72 1040.04 632.72 1037.93 623.39 1041.05 623.22"
        />
        <path
          d="M1087.41,621.36 L1085.11,623.26 L1077.41,629.59 C1077.41,629.59 1056.59,640.7 1050.85,630.15 C1045.79,620.85 1069.4,614.21 1075.09,612.76 L1076.3,612.47 L1087.41,621.36 Z"
          id="Path"
          fill="#FBBEBE"
          fillRule="nonzero"
        />
        <path
          d="M998.45,530.36 C998.45,530.36 1002.52,532.21 1003.45,534.8 C1004.38,537.39 998.45,530.36 998.45,530.36 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M985.86,558.13 C985.86,558.13 979.94,565.35 982.34,568.13 C984.74,570.91 985.86,558.13 985.86,558.13 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1091.76,534.46 C1091.76,534.46 1086.21,535.02 1086.02,539.83 L1091.76,534.46 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1040.29,610.34 C1040.85,609.78 1053.62,590.9 1056.59,592.57 L1040.29,610.34 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1064.18,487.59 C1064.18105,491.218869 1063.28442,494.791647 1061.57,497.99 L1061.41,497.99 C1060.01,497.69 1059.28,496.07 1058.22,495.05 C1056.87588,493.768613 1054.86433,493.486996 1053.22,494.35 C1051.56528,495.33843 1050.61247,497.178193 1050.76,499.1 C1050.06,496.1 1050.28,492.98 1049.59,490.01 C1048.9,487.04 1046.83,484.01 1043.99,484.01 C1042.77,484.01 1041.34,484.46 1040.46,483.54 C1039.93,482.99 1039.82,482.12 1039.46,481.45 C1037.46,478.16 1031.26,479.82 1028.74,481.51 C1026.22,483.2 1023.29,485.88 1020.16,487.32 C1020.24837,475.153167 1030.18317,465.361634 1042.35,465.45 C1054.51683,465.538366 1064.30837,475.473167 1064.22,487.64 L1064.18,487.59 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1039.42,480.84 C1039.82,481.51 1039.93,482.38 1040.42,482.94 C1041.3,483.85 1042.73,483.38 1043.95,483.4 C1046.79,483.45 1048.87,486.46 1049.55,489.4 C1050.23,492.34 1050.02,495.52 1050.73,498.48 C1050.56492,496.559871 1051.51808,494.715795 1053.18,493.74 C1054.82336,492.880705 1056.83079,493.157731 1058.18,494.43 C1059.24,495.43 1059.97,497.08 1061.37,497.37 C1062.77,497.66 1064.11,496.32 1064.61,494.85 C1064.96969,493.330934 1065.23685,491.791437 1065.41,490.24 C1066.04,487.36 1067.93,484.99 1068.97,482.24 C1070.2108,478.899232 1070.17877,475.218664 1068.88,471.9 C1068.18,470.16 1067.15,468.6 1066.45,466.9 C1065.38,464.27 1065.1,461.29 1063.8,458.78 C1061.64481,454.580068 1056.756,452.570269 1052.27,454.04 C1050.27,454.8 1048.51,456.26 1046.47,456.92 C1043.73,457.8 1040.81,457.14 1037.98,456.74 C1035.15,456.34 1031.98,456.31 1029.74,458.17 C1027.12,460.32 1026.4,464.35 1023.94,466.7 C1022.94,467.7 1021.62,468.32 1020.53,469.23 C1019.3352,470.111311 1018.62706,471.505342 1018.62,472.99 C1018.79,474.91 1020.62,476.65 1019.97,478.43 C1019.73052,478.942474 1019.39044,479.401571 1018.97,479.78 C1016.90829,481.943853 1015.375,484.555239 1014.49,487.41 C1019.49,488.95 1024.81,483.49 1028.68,480.91 C1031.22,479.22 1037.39,477.56 1039.42,480.84 Z"
          id="Path"
          fill="#7C5C5C"
          fillRule="nonzero"
        />
        <path
          d="M1087.41,621.36 L1085.11,623.26 C1083.11,619.87 1074.73,613.11 1074.73,613.11 L1075.09,612.76 L1076.3,612.47 L1087.41,621.36 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1089.63,617.93 C1089.63,617.93 1088.81,619.99 1087.95,621.77 C1087.09,623.55 1086.16,625.17 1086.12,623.86 C1086.02,621.26 1075.29,612.56 1075.29,612.56 L1076.74,611.14 L1078.43,609.5 L1089.63,617.93 Z"
          id="Path"
          fill="#E7EFFD"
          fillRule="nonzero"
        />
        <path
          d="M1090,604.23 L1091.22,624.88 C1088.34,620.41 1080.45,608.95 1075.38,609.32 L1087.69,595.16 C1088.20143,594.590115 1088.67257,593.98532 1089.1,593.35 C1089.57,599.25 1090,604.23 1090,604.23 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1089.63,617.93 C1089.63,617.93 1088.81,619.99 1087.95,621.77 C1084.72,617.35 1080.29,612.12 1076.74,611.14 L1078.43,609.5 L1089.63,617.93 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1098.89,543.04 L1102.22,545.63 C1102.22,545.63 1107.78,545.73 1108.33,550.35 C1108.88,554.97 1113.98,557.11 1113.98,557.11 C1113.98,557.11 1117.77,560.91 1117.77,562.67 C1117.77,564.43 1120.64,567.57 1120.64,567.85 C1120.64,568.13 1123.42,573.77 1123.05,574.79 C1122.68,575.81 1126.05,580.25 1124.99,581.92 C1124.15816,583.417591 1123.41683,584.963697 1122.77,586.55 C1122.77,586.55 1118.42,594.88 1116.2,596.45 C1113.98,598.02 1103.8,611.27 1103.8,611.27 C1103.8,611.27 1092.87,623.85 1092.87,627.74 C1092.87,627.74 1082.23,609.97 1075.93,610.43 L1088.24,596.27 C1088.24,596.27 1090.37,593.95 1090.47,592.57 C1090.57,591.19 1096.39,584.79 1099.17,584.51 C1099.17,584.51 1099.63,580.72 1098.43,580.62 C1097.23,580.52 1096.21,577.62 1096.21,577.62 C1096.21,577.62 1088.06,567.99 1087.97,561.88 C1087.88,555.77 1098.89,543.04 1098.89,543.04 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <path
          d="M1103.8,551.83 C1103.8,551.83 1096.02,557.57 1097.69,559.43 C1099.36,561.29 1103.8,551.83 1103.8,551.83 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1104.17,575.53 C1104.17,575.53 1118.61,570.9 1120.09,575.53 L1104.17,575.53 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1014.75,821.46 C1014.75,821.46 1006.97,826.56 1003.08,825.81 C1000.38611,825.471018 997.651772,825.922688 995.21,827.11 C992.535426,830.038186 989.159399,832.237249 985.4,833.5 C979.1,835.63 970.31,834.79 965.31,833.13 C962.95,832.34 962.76,831.32 963.9,830.07 C969.33,831.15 981.48,833.3 984.75,831.74 C988.354738,829.826529 991.820005,827.661155 995.12,825.26 C995.12,825.26 1003.12,824.15 1004.19,824.15 C1004.98,824.15 1011.13,821.61 1014.6,820.15 L1014.75,821.46 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1061.84,831.91 C1061.84,832.22 1061.77,832.42 1061.77,832.42 C1061.77,832.42 1059.92,836.49 1049.64,837.97 C1039.36,839.45 1039.37,834.55 1039.37,834.55 L1039.47,833.22 C1042.72,834.46 1049.82,835.83 1061.84,831.91 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1002.29,550.72 C1002.29,550.72 1002.29,571.83 1000.49,573.91 C998.69,575.99 1002.29,550.72 1002.29,550.72 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M1085.74,557.53 L1088.43,565.07 C1088.43,565.07 1089.49,557.67 1085.74,557.53 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <g
          id="Group"
          opacity="0.1"
          transform="translate(1014.000000, 471.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <path
            d="M6.29,5.61 C6.97,3.88 5.19,2.17 4.96,0.31 C4.72089338,0.832499408 4.61769897,1.40694832 4.66,1.98 C4.78,3.39 5.82,4.7 6.09,5.98 C6.1679243,5.86309228 6.23487577,5.73923208 6.29,5.61 L6.29,5.61 Z"
            id="Path"
          />
          <path
            d="M37.01,25.55 C36.35,22.63 36.55,19.55 35.87,16.62 C35.19,13.69 33.11,10.62 30.27,10.62 C29.05,10.62 27.62,11.06 26.74,10.15 C26.2,9.6 26.1,8.73 25.74,8.05 C23.74,4.77 17.54,6.44 15.01,8.12 C11.23,10.63 6.01,15.9 1.17,14.7 C0.94,15.26 0.72,15.83 0.54,16.42 C5.54,17.96 10.86,12.5 14.73,9.92 C17.26,8.24 23.43,6.58 25.46,9.86 C25.86,10.53 25.97,11.4 26.46,11.96 C27.34,12.87 28.77,12.4 29.99,12.42 C32.83,12.47 34.91,15.48 35.59,18.42 C36.27,21.36 36.06,24.54 36.77,27.5 C36.7202495,26.8405243 36.8018241,26.1777309 37.01,25.55 Z"
            id="Path"
          />
          <path
            d="M50.93,22.08 C50.43,23.55 49.11,24.9 47.68,24.6 C46.25,24.3 45.56,22.68 44.5,21.66 C43.1517123,20.3872636 41.1459665,20.1064592 39.5,20.96 C37.9274675,21.9008081 36.9864792,23.618303 37.04,25.45 C37.4114096,24.3184543 38.1877783,23.3640194 39.22,22.77 C40.8633609,21.9107054 42.8707948,22.1877312 44.22,23.46 C45.28,24.46 46.01,26.11 47.41,26.4 C48.81,26.69 50.15,25.35 50.65,23.88 C50.9214459,23.0158253 51.0925709,22.1232907 51.16,21.22 C51.1033248,21.5116432 51.0264735,21.7990005 50.93,22.08 L50.93,22.08 Z"
            id="Path"
          />
          <path
            d="M55.29,9.46 C54.29,12.2 52.36,14.57 51.73,17.46 C51.61,18.04 51.53,18.64 51.46,19.24 C52.1,16.36 53.97,14 55.01,11.24 C55.4740323,10.0067949 55.7602339,8.71383693 55.86,7.4 C55.7227715,8.10018842 55.5322163,8.7888616 55.29,9.46 L55.29,9.46 Z"
            id="Path"
          />
        </g>
        <circle
          id="Oval"
          fill="#E6E8EC"
          fillRule="nonzero"
          cx="935.51"
          cy="547.26"
          r="1"
        />
        <rect
          id="Rectangle"
          fill="#FFFFFF"
          fillRule="nonzero"
          x="849.12"
          y="552.42"
          width="181.18"
          height="208.22"
          rx="6.61"
        />
        <rect
          id="Rectangle"
          fill="#5A5773"
          fillRule="nonzero"
          opacity="0.1"
          x="849.12"
          y="552.42"
          width="181.18"
          height="208.22"
          rx="6.61"
        />
        <rect
          id="Rectangle"
          fill="#FFFFFF"
          fillRule="nonzero"
          x="858.36"
          y="563.04"
          width="162.7"
          height="186.98"
          rx="6.61"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          x="882.03"
          y="600.54"
          width="111.62"
          height="38.52"
          rx="6.03"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          x="886.13"
          y="653.15"
          width="103.43"
          height="7.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          x="868.55"
          y="669.74"
          width="142.32"
          height="7.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          x="868.55"
          y="687.2"
          width="142.32"
          height="7.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          x="868.55"
          y="704.66"
          width="142.32"
          height="7.86"
        />
        <rect
          id="Rectangle"
          fill="#FFFFFF"
          fillRule="nonzero"
          x="0"
          y="483.59"
          width="426.61"
          height="208.22"
          rx="6.61"
        />
        <rect
          id="Rectangle"
          fill="#5A5773"
          fillRule="nonzero"
          opacity="0.1"
          x="0"
          y="483.59"
          width="426.61"
          height="208.22"
          rx="6.61"
        />
        <rect
          id="Rectangle"
          fill="#FFFFFF"
          fillRule="nonzero"
          x="21.76"
          y="494.21"
          width="383.08"
          height="186.98"
          rx="6.61"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          x="77.51"
          y="531.72"
          width="262.81"
          height="38.52"
          rx="6.03"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          x="87.15"
          y="584.32"
          width="243.53"
          height="7.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          x="45.75"
          y="600.91"
          width="335.1"
          height="7.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          x="45.75"
          y="618.37"
          width="335.1"
          height="7.86"
        />
        <rect
          id="Rectangle"
          fill="#6C63FF"
          fillRule="nonzero"
          x="45.75"
          y="635.83"
          width="335.1"
          height="7.86"
        />
        <path
          d="M104.27,841.64 C105.46,837.3 106.27,833.48 106.27,833.48 C106.292249,830.579069 107.056492,827.732092 108.49,825.21 L108.49,824.01 L108.49,824.01 L108.83,815.2 C108.301279,813.578154 107.632076,812.005525 106.83,810.5 C105.35,807.67 107.33,797.58 107.33,797.58 C107.33,797.58 113.76,783.51 112.68,774.38 C111.6,765.25 126.3,734.55 126.3,734.55 C126.339209,731.524658 126.030516,728.504837 125.38,725.55 C125.261842,724.934107 125.228199,724.304981 125.28,723.68 C125.275014,723.603414 125.275014,723.526586 125.28,723.45 L125.28,723.52 C125.71,717.52 130.87,706.52 130.87,706.52 L131.06,685.12 C131.06,685.12 128.52,672.4 134.06,655.67 C136.01,649.83 137.29,645.15 138.13,641.53 C138.23,641.12 138.32,640.73 138.4,640.35 C128.32,638.41 120.62,636.83 120.62,636.83 C120.62,636.83 127.45,612.45 131.62,608.3 C135.79,604.15 139.45,590.73 139.45,590.73 C139.45,590.73 142.19,573.43 139.05,568.23 C135.91,563.03 135.77,554.23 135.77,554.23 C135.77,554.23 128.35,548.4 127.49,545.91 C126.63,543.42 125.26,537.81 125.37,534.91 C125.48,532.01 126.54,529.41 126.28,527.86 C126.02,526.31 128.79,520.57 127.62,517.75 C127.328948,516.883969 127.193524,515.973247 127.22,515.06 C127.22,515.06 127.22,515.06 127.22,514.98 L127.22,514.98 C127.303119,512.558227 127.62128,510.150254 128.17,507.79 C130.443275,506.012792 133.067713,504.738065 135.87,504.05 L136.06,503.39 L136.56,501.68 C136.805859,501.526882 137.059537,501.386692 137.32,501.26 L137.37,500.63 L137.53,498.14 L136.57,492.46 C134.57,482.6 147.69,481.65 147.69,481.65 C148.534582,480.182457 149.891373,479.078507 151.5,478.55 C154.16,477.73 151.38,493.26 150.11,494.21 C149.11,494.92 146.11,499.71 144.66,502.06 L144.66,502.06 L144.42,502.45 C144.630523,502.650693 144.824487,502.868067 145,503.1 L144.37,506.47 L144.27,506.98 C145.095486,508.087196 145.752602,509.310443 146.22,510.61 C146.22,510.61 143.73,513.13 144.1,516.07 C144.207844,518.357036 143.868157,520.643128 143.1,522.8 C143.24,522.65 144.99,520.9 146.65,521.4 C148.31,521.9 152.93,523.49 152.93,523.49 C152.93,523.49 156.4,524.24 156.05,525 C155.7,525.76 158.28,529.24 158.28,529.24 L168.01,520.71 C168.12,520.44 168.22,520.18 168.32,519.91 C168.768249,518.652456 169.10292,517.357278 169.32,516.04 C168.294262,515.760088 167.291356,515.402385 166.32,514.97 C165.344715,514.595001 164.47366,513.991436 163.78,513.21 C162.88,512.05 162.78,510.51 162.43,509.1 C161.79,506.34 160.29,503.84 159.24,501.19 C157.478632,496.743894 157.013997,491.889497 157.9,487.19 C158.113621,485.750007 158.661593,484.380078 159.5,483.19 C161.12,481.14 163.93,480.39 166.02,478.79 C168.11,477.19 169.51,474.66 171.91,473.49 C174.09,472.43 176.68,472.67 179.07,473.15 C183.711199,474.096906 188.13621,475.897428 192.12,478.46 C193.46,479.33 194.93,480.33 196.52,480.1 C197.839502,479.748977 199.002118,478.96333 199.82,477.87 C199.815576,477.823438 199.815576,477.776562 199.82,477.73 L199.93,477.62 C200.838415,479.86473 201.241291,482.281986 201.11,484.7 C201.11,485.07 201.11,485.45 201.03,485.82 C201.03,485.95 201.03,486.08 201.03,486.21 C201.020007,486.319773 201.020007,486.430227 201.03,486.54 L201.03,486.54 C201.025315,486.705418 201.045541,486.8706 201.09,487.03 C201.265534,487.523089 201.549122,487.970679 201.92,488.34 C202.191743,488.674249 202.432723,489.032372 202.64,489.41 C202.64,489.28 202.57,489.15 202.53,489.02 C203.096168,489.917849 203.394505,490.958558 203.39,492.02 C203.413058,492.793666 203.129051,493.545026 202.6,494.11 C202.11669,494.558276 201.58704,494.953837 201.02,495.29 C202.057133,502.727634 198.354707,510.024765 191.74,513.58 C191.62,513.84 191.5,514.11 191.39,514.38 C189.901591,517.558224 189.182191,521.042173 189.29,524.55 C189.29,524.8 189.29,525.05 189.37,525.3 C189.45,525.55 189.6,525.57 189.7,525.71 L189.7,525.71 C189.7,525.71 205.2,526.46 208.98,523.29 C212.76,520.12 217.88,531.72 217.88,531.72 C217.88,531.72 223.4,533.01 224.55,531.98 C225.7,530.95 232.19,532.12 232.19,532.12 C234.940309,529.851536 238.452444,528.717782 242.01,528.95 C244.24591,527.383699 246.693927,526.144538 249.28,525.27 L249.28,525.27 L249.46,525.21 L249.46,525.21 C250.591321,524.841673 251.791634,524.735662 252.97,524.9 C252.97,524.9 260.84,518.9 263.19,515.59 C265.54,512.28 276.57,500.15 276.57,500.09 L276.64,499.49 L276.83,497.67 C277.139761,497.734235 277.454036,497.774355 277.77,497.79 L278.01,497.16 C278.685953,495.402336 279.505385,493.70327 280.46,492.08 C280.46,492.08 280.55,489.77 279.9,489.17 C279.25,488.57 280.53,480.17 280.53,480.17 C280.53,480.17 288.02,464.37 293.71,476.6 C293.71,476.6 305.05,484.81 294.93,493.47 C294.93,493.47 290.93,495.21 290.36,496.68 C289.96,497.68 288.53,500.3 287.57,502.07 L287.14,502.86 L287.25,502.96 L287.05,504.46 L286.97,505.05 C288.76,506.16 289.97,507.24 289.64,508.05 C289.04434,509.360696 288.617591,510.74175 288.37,512.16 C288.37,512.16 274.23,528.46 272.21,535.65 C272.21,535.65 235.15,555.79 223.21,556.87 L224.86,567.71 C225.055761,570.635727 225.102488,573.569522 225,576.5 C224.75,578.8 225.94,589.31 225.94,589.31 C225.94,589.31 227.41,604.77 229.08,606.99 C230.75,609.21 230.08,618.43 230.08,618.43 C230.330595,622.862216 230.959551,627.264906 231.96,631.59 C233.48,637.5 231.96,644.68 231.96,644.68 C231.96,644.68 237.47,658.75 223.37,648.81 C223.37,648.81 216.29,648.1 208.13,647.51 C208.13,647.77 208.13,648.05 208.13,648.32 C208.13,649.38 208.08,650.52 208.05,651.72 C207.85,659.65 207.48,670.57 206.8,678.82 C205.6,693.41 200.04,722.15 200.04,722.15 L199.48,736.67 C199.717781,738.046441 199.804962,739.444683 199.74,740.84 C199.645786,745.963669 198.095402,750.954726 195.27,755.23 L193.78,764.88 C193.78,764.88 190.93,771.16 190.73,774.97 C190.724643,775.281925 190.751451,775.593572 190.81,775.9 C190.883323,776.393054 190.906775,776.892243 190.88,777.39 C190.88,781.79 187.8,792.21 187.8,792.21 C187.8,792.21 187.23,802.82 185.62,803.37 C184.24,803.85 187.2,809.56 188.08,811.2 C188.112752,811.102434 188.13619,811.001986 188.15,810.9 L188.34,811.22 C188.634294,812.091963 188.766473,813.010436 188.73,813.93 C188.851559,815.416076 188.108571,816.839812 186.82,817.59 C183.73,819.32 182.05,820.79 184.59,821.51 C185.527746,821.69281 186.455606,821.923106 187.37,822.2 L187.52,821.85 C188.258953,822.169056 188.67537,822.960248 188.52,823.75 C188.450543,825.007466 188.076471,826.229204 187.43,827.31 C186.198442,830.039075 184.654815,832.616261 182.83,834.99 L181.61,834.81 C181.775024,835.278554 181.996665,835.725195 182.27,836.14 C182.707536,836.82827 183.304354,837.401078 184.01,837.81 C184.658651,838.228974 185.387464,838.508238 186.15,838.63 C187.892438,838.758556 189.498681,839.619822 190.57,841 C192.07,843.11 192.96,845.94 189.73,848.27 L178.22,851.75 C178.22,851.75 158.58,853.54 159.78,849.2 C160.98,844.86 161.78,841.04 161.78,841.04 C161.801054,838.355886 162.444595,835.713262 163.66,833.32 C163.882099,832.931003 164.129288,832.556878 164.4,832.2 L163.71,832.1 C163.71,832.1 162.57,822.35 160.69,820.46 C160.27,820.01 160.18,819.68 160.29,819.46 C160.12,818.93 160.62,818.64 161.29,818.46 C161.29,818.58 161.38,818.71 161.42,818.84 C162.047498,818.734125 162.683929,818.69058 163.32,818.71 C163.32,818.71 164.15,813.66 162.16,811.71 C161.834657,811.275203 161.710908,810.721973 161.82,810.19 C161.824133,809.493456 161.921669,808.800613 162.11,808.13 C162.12957,808.17208 162.153004,808.212252 162.18,808.25 C163.4,803.69 167.18,796.51 167.18,796.51 C167.18,796.51 167.51,791.9 166.31,790 C165.11,788.1 167.44,764.94 167.44,764.94 C167.44,764.94 167.39,753.7 169.02,748.53 C170.65,743.36 167.71,737.08 167.71,737.08 C167.71,737.08 167.71,736.96 167.76,736.75 C167.763303,736.720091 167.763303,736.689909 167.76,736.66 C167.76,736.66 167.86,735.97 168.02,734.9 L168.02,735.01 C168.46,732.01 169.27,726.7 169.81,724.22 C170.58,720.71 170.44,703.76 170.44,703.76 L167.85,696.46 L162.28,708.72 L156.28,725.12 C156.28,725.12 153.47,728.52 153.28,732.12 C153.28,732.3 153.28,732.47 153.28,732.65 C153.304709,733.019587 153.304709,733.390413 153.28,733.76 C153.288286,735.859829 152.63003,737.908126 151.4,739.61 C151.4,739.61 149.67,747.4 147.4,749.31 C145.13,751.22 144.95,755.07 144.95,755.07 C144.95,755.07 141.81,766.35 140.46,768.3 C139.33,769.94 139.09,774.57 139.05,775.99 L139.05,775.99 C139.05,776.25 139.05,776.4 139.05,776.4 C139.05,776.4 138.52,780.46 138.4,783.88 C138.4,784.3 138.4,784.71 138.4,785.09 C138.395111,785.063557 138.395111,785.036443 138.4,785.01 C138.361982,785.938815 138.435846,786.868831 138.62,787.78 C138.62,787.78 138.62,787.89 138.62,787.95 L138.62,787.37 C139.095054,789.711738 139.279779,792.103085 139.17,794.49 C139.08,798.58 138.27,803.4 135.68,806.15 C131.2,810.91 128.53,810.15 128.53,810.15 C128.53,810.15 130.36,816.38 132.85,817.71 C132.945903,817.760635 133.036374,817.820949 133.12,817.89 C133.12,817.77 133.12,817.65 133.19,817.54 C133.724889,818.186939 133.964267,819.028387 133.85,819.86 C133.93,822.57 132.05,826.86 130.35,828.86 C129.731069,829.431552 128.977753,829.837448 128.16,830.04 C128.284481,830.134672 128.414733,830.221506 128.55,830.3 C128.827362,830.464183 129.114572,830.611128 129.41,830.74 C129.813397,830.936773 130.245417,831.068404 130.69,831.13 C132.435711,831.247229 134.046304,832.110827 135.11,833.5 C136.61,835.6 137.5,838.43 134.27,840.76 L122.76,844.24 C122.76,844.24 103.06,845.98 104.27,841.64 Z"
          id="Path"
          fill="url(#linearGradient-3)"
          fillRule="nonzero"
        />
        <path
          d="M178.62,851.77 L189.77,848.28 C192.9,845.94 192.04,843.11 190.59,841 C189.577193,839.631775 188.017807,838.773565 186.32,838.65 C185.574785,838.52707 184.865122,838.243887 184.24,837.82 C183.559121,837.407503 182.986579,836.838389 182.57,836.16 C181.818505,834.854033 181.44137,833.366255 181.48,831.86 C181.48,831.86 169.54,827.86 166.1,831.27 C165.491894,831.88925 164.976558,832.593205 164.57,833.36 C163.389945,835.76439 162.761335,838.401821 162.73,841.08 C162.73,841.08 161.97,844.89 160.8,849.24 C159.63,853.59 178.62,851.77 178.62,851.77 Z"
          id="Path"
          fill="#2D293D"
          fillRule="nonzero"
        />
        <path
          d="M125.01,844.28 L136.16,840.79 C139.29,838.45 138.43,835.62 136.98,833.52 C135.96695,832.145461 134.403075,831.283137 132.7,831.16 C132.268474,831.102879 131.849436,830.974464 131.46,830.78 C131.174566,830.646767 130.8974,830.496496 130.63,830.33 C127.63,828.52 127.86,824.33 127.86,824.33 C127.86,824.33 115.92,820.33 112.48,823.74 C112.018551,824.20015 111.609398,824.709914 111.26,825.26 C109.862342,827.800923 109.119972,830.650114 109.1,833.55 C109.1,833.55 108.33,837.37 107.17,841.71 C106.01,846.05 125.01,844.28 125.01,844.28 Z"
          id="Path"
          fill="#2D293D"
          fillRule="nonzero"
        />
        <path
          d="M166.09,831.27 C165.48543,831.889918 164.973486,832.593839 164.57,833.36 L164.57,833.36 L182.57,836.15 C181.818505,834.844033 181.44137,833.356255 181.48,831.85 C181.48,831.85 169.57,827.86 166.09,831.27 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M111.26,825.3 L111.13,828.69 C113.77,833.44 127.42,832.95 131.46,830.78 C131.174566,830.646767 130.8974,830.496496 130.63,830.33 C127.63,828.52 127.86,824.33 127.86,824.33 C127.86,824.33 115.92,820.33 112.48,823.74 C112.016186,824.212662 111.606952,824.735945 111.26,825.3 L111.26,825.3 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M109.67,810.62 C110.464533,812.129119 111.13346,813.701097 111.67,815.32 L111.18,827.46 C114.06,832.66 130.12,831.58 132.38,828.9 C134.64,826.22 137.22,819.07 134.81,817.75 C132.4,816.43 130.63,810.19 130.63,810.19 C130.63,810.19 133.22,810.91 137.57,806.19 C141.92,801.47 141.1,790.46 140.42,787.82 C139.74,785.18 140.87,776.44 140.87,776.44 C140.87,776.44 140.95,770.28 142.26,768.33 C143.57,766.38 146.62,755.1 146.62,755.1 C146.62,755.1 146.76,751.25 148.99,749.34 C151.22,747.43 152.91,739.63 152.91,739.63 C154.247744,737.7201 154.880474,735.404802 154.7,733.08 C154.39,729.22 157.62,725.18 157.62,725.18 L163.49,708.78 L168.89,696.51 L171.38,703.84 C171.38,703.84 171.5,720.79 170.75,724.3 C170,727.81 168.75,737.16 168.75,737.16 C168.75,737.16 171.59,743.43 170.01,748.61 C168.43,753.79 168.45,765.02 168.45,765.02 C168.45,765.02 166.17,788.19 167.33,790.08 C168.49,791.97 168.16,796.58 168.16,796.58 C168.16,796.58 161.34,809.87 163.26,811.8 C165.18,813.73 164.38,818.8 164.38,818.8 C164.38,818.8 160.08,818.63 161.85,820.55 C163.62,822.47 164.57,832.14 164.57,832.14 L183.08,835.01 C184.85367,832.624221 186.349971,830.044276 187.54,827.32 C190.22,821.73 187.28,822.23 184.83,821.52 C182.38,820.81 184,819.33 186.99,817.6 C189.98,815.87 188.45,811.65 188.45,811.65 C188.45,811.65 184.28,803.94 185.85,803.39 C187.42,802.84 187.97,792.23 187.97,792.23 C187.97,792.23 191.53,779.73 190.89,776.32 C190.25,772.91 193.8,764.88 193.8,764.88 L195.24,755.24 C198.745904,749.873049 200.198118,743.421527 199.33,737.07 L199.91,722.15 C199.91,722.15 205.35,693.46 206.57,678.82 C207.33,669.48 207.71,656.71 207.88,648.74 C207.98,644.26 208.02,641.3 208.02,641.3 L141.85,631.82 C141.619864,635.13489 141.087656,638.421857 140.26,641.64 C139.45,645.27 138.2,649.95 136.26,655.79 C130.84,672.52 133.26,685.24 133.26,685.24 L133.05,706.64 C133.05,706.64 126.65,720.72 127.7,725.69 C128.327228,728.647922 128.622389,731.666605 128.58,734.69 C128.58,734.69 114.34,765.37 115.38,774.46 C116.42,783.55 110.17,797.67 110.17,797.67 C110.17,797.67 108.24,807.79 109.67,810.62 Z"
          id="Path"
          fill="#575988"
          fillRule="nonzero"
        />
        <path
          d="M150.74,731.96 L130.62,728.46 C130.62,728.46 141.63,740.62 150.74,731.96 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.05"
        />
        <path
          d="M134.3,708.85 C134.3,708.85 133.3,715.97 137.61,718.85 C137.57,718.83 129.82,717.3 134.3,708.85 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M136.42,686.13 C136.42,686.13 152.79,700.7 158.98,699.79 C165.17,698.88 136.42,686.13 136.42,686.13 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M175.57,739.46 C175.57,739.46 188.3,742.88 188.49,748.04 C188.68,753.2 175.57,739.46 175.57,739.46 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M170.26,803.46 C170.26,803.46 188.26,807.54 183.04,809.65 C177.82,811.76 169.27,813.28 169.27,813.28 C169.27,813.28 163.41,813.38 170.26,803.46 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.05"
        />
        <g
          id="Group"
          opacity="0.05"
          transform="translate(109.000000, 640.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <path
            d="M77.57,173.46 C78.513619,172.916735 79.1606611,171.975583 79.33,170.9 L79.5,171.23 C79.5,171.23 81.04,175.44 78.04,177.23 C77.7,177.42 77.38,177.62 77.04,177.81 C76.51,177.69 75.93,177.59 75.38,177.43 C72.94,176.68 74.57,175.2 77.57,173.46 Z"
            id="Path"
          />
          <path
            d="M54.23,171.34 C53.75,170.86 53.82,169.68 54.23,168.17 C54.9187661,169.564484 55.2160053,171.119805 55.09,172.67 C54.9087259,172.166777 54.6145274,171.711796 54.23,171.34 L54.23,171.34 Z"
            id="Path"
          />
          <path
            d="M59.97,94.94 C60.5667015,96.7877036 60.9032653,98.7094826 60.97,100.65 C60.6757758,99.2997134 60.2538787,97.9804479 59.71,96.71 C59.71,96.71 59.82,96.02 59.97,94.94 Z"
            id="Path"
          />
          <path
            d="M18.74,85.27 C18.6382488,84.7127979 18.6013365,84.1456906 18.63,83.58 C18.82,84.74 18.94,85.81 19.01,86.75 C18.93,86.27 18.84,85.78 18.74,85.27 Z"
            id="Path"
          />
          <path
            d="M58.3,149.63 C57.9994446,148.513113 57.8912319,147.353209 57.98,146.2 C58.495359,147.587305 58.7397766,149.060599 58.7,150.54 C58.602895,150.222 58.4686348,149.916558 58.3,149.63 Z"
            id="Path"
          />
          <path
            d="M53.38,178.46 C54.217603,181.584676 54.8028189,184.771595 55.13,187.99 L73.64,190.86 C75.4201589,188.476691 76.9200324,185.896372 78.11,183.17 C78.35,182.68 78.53,182.24 78.69,181.84 C79.78,182.39 80.18,183.57 78.58,186.89 C77.3888337,189.610569 75.8925815,192.187075 74.12,194.57 L55.57,191.72 C55.57,191.72 54.57,181.98 52.78,180.07 C51.95,179.12 52.57,178.69 53.38,178.46 Z"
            id="Path"
          />
          <path
            d="M79.01,151.81 C79.01,151.81 78.45,162.42 76.89,162.97 L76.89,162.97 C76.18,161.18 75.72,159.5 76.42,159.25 C77.98,158.69 78.55,148.09 78.55,148.09 C78.55,148.09 82.11,135.6 81.47,132.18 C80.83,128.76 84.37,120.75 84.37,120.75 L85.82,111.1 C89.3259044,105.733049 90.7781183,99.281527 89.91,92.93 L90.48,78.01 C90.48,78.01 95.9,49.27 97.08,34.68 C97.83,25.34 98.21,12.57 98.39,4.6 C98.39,3.16 98.45,1.88 98.47,0.8 L99,0.88 C99,0.88 99,3.88 98.86,8.31 C98.69,16.31 98.31,29.06 97.55,38.4 C96.37,52.98 90.96,81.73 90.96,81.73 L90.38,96.64 C91.2483243,102.990195 89.7998961,109.440671 86.3,114.81 L84.84,124.46 C84.84,124.46 81.29,132.46 81.93,135.9 C82.57,139.34 79.01,151.81 79.01,151.81 Z"
            id="Path"
          />
          <path
            d="M22.92,184.77 C24.5110774,182.640501 25.6107458,180.18503 26.14,177.58 C27.97,179.36 25.54,185.93 23.39,188.48 C21.24,191.03 5.07,192.24 2.19,187.05 L2.3,184.12 C6.3,188.4 20.78,187.31 22.92,184.77 Z"
            id="Path"
          />
          <path
            d="M0.21,166.46 C1.00453322,167.969119 1.67345974,169.541097 2.21,171.16 L2.12,173.31 C1.70070508,172.239726 1.22674815,171.19168 0.7,170.17 C0.259481642,168.944052 0.0822974448,167.639022 0.18,166.34 L0.21,166.46 Z"
            id="Path"
          />
          <path
            d="M22.57,169.78 C22.029015,168.574985 21.5680164,167.335634 21.19,166.07 C21.19,166.07 23.78,166.78 28.12,162.02 C31.28,158.55 31.71,151.8 31.45,147.36 C32.13,150.01 32.94,160.97 28.6,165.73 C25.74,168.85 23.65,169.62 22.57,169.78 Z"
            id="Path"
          />
          <path
            d="M31.88,135.98 C31.4913875,139.002093 31.2710476,142.043451 31.22,145.09 C31.160438,144.605499 31.0736338,144.124738 30.96,143.65 C30.29,141 31.4,132.27 31.4,132.27 C31.4,132.27 31.49,126.11 32.79,124.16 C34.09,122.21 37.15,110.93 37.15,110.93 C37.15,110.93 37.3,107.09 39.53,105.17 C41.76,103.25 43.45,95.46 43.45,95.46 C44.7831914,93.5479662 45.4154691,91.2343243 45.24,88.91 C44.93,85.05 48.16,81.01 48.16,81.01 L54.03,64.61 L59.43,52.34 L61.92,59.68 C61.92,59.68 61.92,60.58 61.92,62.02 L59.92,56.02 L54.52,68.28 L48.65,84.69 C48.65,84.69 45.42,88.69 45.73,92.59 C45.9104739,94.914802 45.2777436,97.2301001 43.94,99.14 C43.94,99.14 42.25,106.93 40.02,108.84 C37.79,110.75 37.65,114.6 37.65,114.6 C37.65,114.6 34.59,125.88 33.29,127.84 C31.99,129.8 31.88,135.98 31.88,135.98 Z"
            id="Path"
          />
        </g>
        <path
          d="M138.85,492.56 L139.79,498.22 L139.63,500.72 L139.51,502.56 L145.9,503.47 L146.67,502.17 L146.67,502.17 C148.09,499.82 151.03,495.03 151.96,494.31 C153.18,493.36 155.9,477.83 153.32,478.65 C151.746722,479.191949 150.429068,480.29593 149.62,481.75 C149.62,481.75 136.96,482.71 138.85,492.56 Z"
          id="Path"
          fill="#FFCDD3"
          fillRule="nonzero"
        />
        <path
          d="M139.51,502.56 L145.9,503.47 L146.67,502.17 L146.67,502.17 C144.970905,500.094851 142.05024,499.494028 139.67,500.73 L139.51,502.56 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M137.77,505.54 L146.16,507.83 L146.38,506.57 L146.99,503.2 C146.102472,501.925002 144.742786,501.056951 143.212672,500.788477 C141.682558,500.520003 140.108573,500.873312 138.84,501.77 L138.36,503.48 L137.77,505.54 Z"
          id="Path"
          fill="#DCE6F2"
          fillRule="nonzero"
        />
        <path
          d="M275.31,498.46 L284.15,503.66 C284.15,503.66 284.52,502.95 285.04,501.98 C285.97,500.21 287.35,497.55 287.74,496.59 C288.33,495.12 292.17,493.37 292.17,493.37 C301.98,484.7 291.01,476.51 291.01,476.51 C285.51,464.28 278.25,480.09 278.25,480.09 C278.25,480.09 277,488.52 277.63,489.09 C278.26,489.66 278.17,492 278.17,492 C277.238086,493.624882 276.442043,495.323997 275.79,497.08 C275.48,497.91 275.31,498.46 275.31,498.46 Z"
          id="Path"
          fill="#FFCDD3"
          fillRule="nonzero"
        />
        <path
          d="M275.31,498.46 L284.15,503.66 C284.15,503.66 284.52,502.95 285.04,501.98 C283.8,500.87 279.42,496.98 277.93,497.14 C277.218449,497.211312 276.501551,497.211312 275.79,497.14 C275.48,497.91 275.31,498.46 275.31,498.46 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M274.28,501.13 L284.28,506.52 L284.56,504.34 L284.76,502.84 C284.76,502.84 279.08,497.58 277.34,497.7 C276.452589,497.789174 275.557018,497.752139 274.68,497.59 L274.5,499.41 L274.28,501.13 Z"
          id="Path"
          fill="#DCE6F2"
          fillRule="nonzero"
        />
        <path
          d="M162.02,530.8 C162.02,530.8 206.09,537.5 197.92,534.5 C192.23,532.4 190.08,528.65 189.76,524.57 C189.650369,521.069257 190.3341,517.589067 191.76,514.39 C192.917664,511.640492 194.348155,509.014016 196.03,506.55 C196.03,506.55 162.91,486.64 169.03,503.82 C169.975724,506.418885 170.51866,509.147054 170.64,511.91 C170.736103,514.652397 170.33636,517.389621 169.46,519.99 C168.022967,524.209803 165.448297,527.950688 162.02,530.8 L162.02,530.8 Z"
          id="Path"
          fill="#FFCDD3"
          fillRule="nonzero"
        />
        <path
          d="M169.07,503.82 C170.015724,506.418885 170.55866,509.147054 170.68,511.91 C173.76,514.7 177.26,514.66 181.75,514.83 C185.2,514.97 188.98,515.95 191.75,514.39 C192.907664,511.640492 194.338155,509.014016 196.02,506.55 C196.02,506.55 162.95,486.64 169.07,503.82 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <circle
          id="Oval"
          fill="#FFCDD3"
          fillRule="nonzero"
          cx="183.01"
          cy="497.73"
          r="18.31"
        />
        <path
          d="M162.02,530.8 C162.02,530.8 206.09,537.5 197.92,534.5 C192.23,532.4 190.08,528.65 189.76,524.57 C187.65,522.1 183.29,520.21 180.48,519.18 C177.921548,518.216432 175.128693,518.062825 172.48,518.74 C171.423624,519.005826 170.412591,519.42709 169.48,519.99 C168.037408,524.212139 165.455646,527.953271 162.02,530.8 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M137.77,505.54 L146.16,507.83 L146.38,506.57 C144.629092,503.959374 141.431195,502.724186 138.38,503.48 L137.77,505.54 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M274.28,501.13 L284.28,506.52 L284.56,504.34 C281.318616,502.465859 277.942689,500.834718 274.46,499.46 L274.28,501.13 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M140.22,641.64 C157.22,645.01 181.52,649.47 185.43,648.44 C188.68,647.59 198.93,648.09 207.84,648.74 C207.94,644.26 207.98,641.3 207.98,641.3 L141.81,631.82 C141.579864,635.13489 141.047656,638.421857 140.22,641.64 L140.22,641.64 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M123.29,636.96 C123.29,636.96 179.35,648.82 185.48,647.21 C191.61,645.6 222.63,648.79 222.63,648.79 C236.26,658.71 230.95,644.65 230.95,644.65 C230.95,644.65 232.46,637.47 230.95,631.56 C229.98288,627.231097 229.37746,622.829259 229.14,618.4 C229.14,618.4 229.81,609.18 228.2,606.97 C226.59,604.76 225.2,589.29 225.2,589.29 C225.2,589.29 224.07,578.78 224.31,576.48 C224.55,574.18 224.19,567.69 224.19,567.69 L222.6,556.85 C234.19,555.76 270.08,535.58 270.08,535.58 C272.08,528.42 285.77,512 285.77,512 C286.015624,510.5849 286.431999,509.20482 287.01,507.89 C288.01,505.47 274.38,500.02 274.38,500.02 C274.38,500.02 263.57,512.23 261.33,515.53 C259.09,518.83 251.42,524.85 251.42,524.85 C250.277897,524.690936 249.114504,524.79701 248.02,525.16 L247.84,525.16 L247.84,525.16 C245.340809,526.045722 242.983019,527.288614 240.84,528.85 C237.375879,528.633858 233.96303,529.770279 231.32,532.02 C231.32,532.02 225.05,530.86 223.94,531.89 C222.83,532.92 217.48,531.64 217.48,531.64 C217.48,531.64 212.48,520.06 208.87,523.23 C205.26,526.4 190.2,525.67 190.2,525.67 C188.31,522.93 183.51,520.84 180.51,519.74 C177.952636,518.771281 175.158177,518.617586 172.51,519.3 C171.360894,519.582633 170.268516,520.059491 169.28,520.71 L159.84,529.27 C159.84,529.27 157.35,525.79 157.69,525.03 C158.03,524.27 154.69,523.53 154.69,523.53 C154.69,523.53 150.28,521.97 148.61,521.45 C146.94,520.93 145.31,522.69 145.17,522.85 C145.933457,520.691956 146.273006,518.40679 146.17,516.12 C145.82,513.18 148.22,510.65 148.22,510.65 C143.35,497.22 130.78,507.83 130.78,507.83 C130.78,507.83 129.11,515 130.24,517.83 C131.37,520.66 128.68,526.39 128.92,527.94 C129.16,529.49 128.15,532.07 128.04,534.99 C127.93,537.91 129.25,543.51 130.04,545.99 C130.83,548.47 138.04,554.31 138.04,554.31 C138.04,554.31 138.17,563.09 141.2,568.31 C144.23,573.53 141.57,590.81 141.57,590.81 C141.57,590.81 137.97,604.22 133.96,608.38 C129.95,612.54 123.29,636.96 123.29,636.96 Z"
          id="Path"
          fill="#656691"
          fillRule="nonzero"
        />
        <path
          d="M209.45,538.94 C209.45,538.94 211.34,533.94 212.89,533.53 C214.443712,533.025394 215.960665,532.413935 217.43,531.7 L216.51,529.77 C216.51,529.77 210.67,531.14 209.69,532.77 C208.71,534.4 209.45,538.94 209.45,538.94 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M240.79,528.91 C241.04,530.46 254.67,532.37 254.67,532.37 L248.02,525.16 L248.02,525.16 L247.85,525.16 L247.85,525.16 C245.3264,526.059055 242.947887,527.32243 240.79,528.91 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <circle
          id="Oval"
          fill="#575988"
          fillRule="nonzero"
          cx="281.2"
          cy="509.32"
          r="1.23"
        />
        <circle
          id="Oval"
          fill="#575988"
          fillRule="nonzero"
          cx="279.53"
          cy="511.72"
          r="1.23"
        />
        <circle
          id="Oval"
          fill="#575988"
          fillRule="nonzero"
          cx="277.9"
          cy="513.93"
          r="1.23"
        />
        <circle
          id="Oval"
          fill="#575988"
          fillRule="nonzero"
          cx="276.2"
          cy="516.33"
          r="1.23"
        />
        <circle
          id="Oval"
          fill="#575988"
          fillRule="nonzero"
          cx="131.25"
          cy="510.62"
          r="1"
        />
        <circle
          id="Oval"
          fill="#575988"
          fillRule="nonzero"
          cx="131.01"
          cy="512.88"
          r="1"
        />
        <circle
          id="Oval"
          fill="#575988"
          fillRule="nonzero"
          cx="130.78"
          cy="515.14"
          r="1"
        />
        <path
          d="M207.77,580.61 C207.92,580.44 171.57,622.88 145.63,596.55 C145.63,596.55 187.93,603.95 207.77,580.61 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M226.81,604.14 C226.81,604.14 206.04,603.91 203.64,609.79 L203.4,616 C204.575654,616.709145 206.032859,616.765772 207.26,616.15 C209.4,615.1 222.18,609.21 226.49,612.45 L226.81,604.14 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M226.42,604.12 C226.42,604.12 206.57,603.9 204.27,609.51 L204.04,615.43 C205.163121,616.111329 206.558482,616.16427 207.73,615.57 C209.73,614.57 222,608.96 226.12,612.04 L226.42,604.12 Z"
          id="Path"
          fill="#656691"
          fillRule="nonzero"
        />
        <path
          d="M217.22,558.66 C214.908459,563.48064 212.031573,568.009135 208.65,572.15 C204.954592,576.729122 200.536501,580.674329 195.57,583.83 C195.57,583.83 216.76,561.46 217.22,558.66 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M224.93,534.82 C224.93,534.82 220.93,549.63 211.78,554.36 L224.93,534.82 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M230.18,536.53 C230.28,536.26 232.8,548.47 217.97,554.6 C217.97,554.6 224.24,552.73 230.18,536.53 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M139.99,523.03 C140.22,523.03 132.62,527.48 130.52,529.59 C130.57,529.59 135.62,522.55 139.99,523.03 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M187.32,514.51 C187.132433,515.480352 186.586148,516.344411 185.79,516.93 C185.242758,517.169748 184.64637,517.276001 184.05,517.24 C178.46,517.38 172.64,517.4 167.57,515.05 C166.621287,514.673259 165.779875,514.068817 165.12,513.29 C164.24,512.13 164.12,510.6 163.81,509.18 C163.19,506.42 161.74,503.93 160.73,501.28 C159.029196,496.818474 158.589801,491.974752 159.46,487.28 C159.660392,485.844744 160.190962,484.475531 161.01,483.28 C162.57,481.23 165.3,480.48 167.32,478.87 C169.34,477.26 170.7,474.74 173.04,473.56 C175.14,472.5 177.65,472.73 179.96,473.22 C184.494539,474.170384 188.805368,475.979575 192.66,478.55 C193.95,479.42 195.37,480.41 196.91,480.18 C198.230057,479.813628 199.38219,479.000773 200.17,477.88 C201.160321,480.422934 201.523898,483.166907 201.23,485.88 C201.159901,486.276929 201.159901,486.683071 201.23,487.08 C201.400797,487.568436 201.673493,488.014975 202.03,488.39 C203.34,490.04 204.11,492.6 202.69,494.16 C202.07,494.84 201.14,495.16 200.54,495.89 C199.46,497.13 199.73,498.99 199.69,500.64 C199.72629,501.213588 199.563839,501.782163 199.23,502.25 C198.599,502.78428 197.736675,502.954476 196.95,502.7 C196.178685,502.437153 195.363238,502.328427 194.55,502.38 C193.682332,502.629512 192.924592,503.165217 192.4,503.9 C189.69,507.04 188.57,510.61 187.32,514.51 Z"
          id="Path"
          fill="#2D293D"
          fillRule="nonzero"
        />
        <g
          id="Group"
          opacity="0.1"
          transform="translate(164.000000, 477.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <path
            d="M0.57,34.85 C1.22642319,35.6349297 2.06860569,36.2433636 3.02,36.62 C8.09,38.97 13.91,38.94 19.5,38.81 C20.0974659,38.8476394 20.6950185,38.7377446 21.24,38.49 C22.0377265,37.9102843 22.5847878,37.0485733 22.77,36.08 C24,32.17 25.14,28.61 27.85,25.43 C28.3729659,24.6914822 29.1308976,24.1521169 30,23.9 C30.8130551,23.8534797 31.6275373,23.9620773 32.4,24.22 C33.1863071,24.4805267 34.0516398,24.3097374 34.68,23.77 C35.0146254,23.3063364 35.1772787,22.740586 35.14,22.17 C35.14,20.52 34.91,18.66 35.99,17.41 C36.59,16.72 37.52,16.41 38.14,15.69 C38.9600771,14.6512884 39.1479693,13.247849 38.63,12.03 C39.55,13.62 39.9,15.63 38.7,16.94 C38.08,17.62 37.16,17.94 36.55,18.67 C35.47,19.91 35.75,21.77 35.71,23.42 C35.7476264,23.9952482 35.5812017,24.5653413 35.24,25.03 C34.6098687,25.5660811 33.7465562,25.7364718 32.96,25.48 C32.1921334,25.2171818 31.3799592,25.1084388 30.57,25.16 C29.6972295,25.4100894 28.9355007,25.9496474 28.41,26.69 C25.71,29.86 24.57,33.43 23.33,37.33 C23.2947449,38.1387493 22.9219052,38.895637 22.3022037,39.4164905 C21.6825021,39.9373439 20.872756,40.1744087 20.07,40.07 C14.48,40.2 8.66,40.22 3.58,37.87 C2.63207519,37.4918186 1.79098871,36.8876095 1.13,36.11 C0.79993438,35.653409 0.552829635,35.1422746 0.4,34.6 C0.449713026,34.6878555 0.506571568,34.771471 0.57,34.85 L0.57,34.85 Z"
            id="Path"
          />
          <path
            d="M37.19,9.56 C36.9419128,9.27119818 36.7639464,8.92895507 36.67,8.56 C36.5999007,8.1630712 36.5999007,7.7569288 36.67,7.36 C36.9115679,5.12215864 36.7076466,2.85863285 36.07,0.7 L36.17,0.59 C37.1687263,3.1308058 37.5359011,5.87603778 37.24,8.59 C37.1943907,8.91119054 37.1776571,9.23582224 37.19,9.56 L37.19,9.56 Z"
            id="Path"
          />
        </g>
        <path
          d="M190.15,525.73 C190.15,525.73 167.15,527.88 165.25,524.36"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M146.08,514.56 C146.08,514.56 133.37,514.09 130.4,518.74"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
      </g>
    </g>
  </svg>
);

export default Waiting;
